(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("os"), require("child_process"));
	else if(typeof define === 'function' && define.amd)
		define(["os", "child_process"], factory);
	else if(typeof exports === 'object')
		exports["parallel-es"] = factory(require("os"), require("child_process"));
	else
		root["parallel-es"] = factory(root["os"], root["child_process"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_129__, __WEBPACK_EXTERNAL_MODULE_159__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 174);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(79);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 2 */
/***/ (function(module, exports) {

var core = module.exports = {version: '2.4.0'};
if(typeof __e == 'number')__e = core; // eslint-disable-line no-undef

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

var store      = __webpack_require__(35)('wks')
  , uid        = __webpack_require__(24)
  , Symbol     = __webpack_require__(4).Symbol
  , USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function(name){
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;

/***/ }),
/* 4 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
if(typeof __g == 'number')__g = global; // eslint-disable-line no-undef

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(4)
  , core      = __webpack_require__(2)
  , ctx       = __webpack_require__(16)
  , hide      = __webpack_require__(11)
  , PROTOTYPE = 'prototype';

var $export = function(type, name, source){
  var IS_FORCED = type & $export.F
    , IS_GLOBAL = type & $export.G
    , IS_STATIC = type & $export.S
    , IS_PROTO  = type & $export.P
    , IS_BIND   = type & $export.B
    , IS_WRAP   = type & $export.W
    , exports   = IS_GLOBAL ? core : core[name] || (core[name] = {})
    , expProto  = exports[PROTOTYPE]
    , target    = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE]
    , key, own, out;
  if(IS_GLOBAL)source = name;
  for(key in source){
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if(own && key in exports)continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function(C){
      var F = function(a, b, c){
        if(this instanceof C){
          switch(arguments.length){
            case 0: return new C;
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if(IS_PROTO){
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if(type & $export.R && expProto && !expProto[key])hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library` 
module.exports = $export;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var anObject       = __webpack_require__(7)
  , IE8_DOM_DEFINE = __webpack_require__(57)
  , toPrimitive    = __webpack_require__(37)
  , dP             = Object.defineProperty;

exports.f = __webpack_require__(8) ? Object.defineProperty : function defineProperty(O, P, Attributes){
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if(IE8_DOM_DEFINE)try {
    return dP(O, P, Attributes);
  } catch(e){ /* empty */ }
  if('get' in Attributes || 'set' in Attributes)throw TypeError('Accessors not supported!');
  if('value' in Attributes)O[P] = Attributes.value;
  return O;
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14);
module.exports = function(it){
  if(!isObject(it))throw TypeError(it + ' is not an object!');
  return it;
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(13)(function(){
  return Object.defineProperty({}, 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(58)
  , defined = __webpack_require__(30);
module.exports = function(it){
  return IObject(defined(it));
};

/***/ }),
/* 10 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function(it, key){
  return hasOwnProperty.call(it, key);
};

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var dP         = __webpack_require__(6)
  , createDesc = __webpack_require__(19);
module.exports = __webpack_require__(8) ? function(object, key, value){
  return dP.f(object, key, createDesc(1, value));
} : function(object, key, value){
  object[key] = value;
  return object;
};

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(85), __esModule: true };

/***/ }),
/* 13 */
/***/ (function(module, exports) {

module.exports = function(exec){
  try {
    return !!exec();
  } catch(e){
    return true;
  }
};

/***/ }),
/* 14 */
/***/ (function(module, exports) {

module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionCall; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


/**
 * @module parallel
 */
/** */
/**
 * Represents a function call
 */
var FunctionCall = function () {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FunctionCall, null, [{
        key: "create",
        value: function create(func) {
            for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                args[_key - 1] = arguments[_key];
            }

            return new FunctionCall(func, args);
        }
        /**
         * Creates a function call for a function with with many arguments
         * @param func the function to call
         * @param params the parameters to pass
         * @returns the function call
         */

    }, {
        key: "createUnchecked",
        value: function createUnchecked(func) {
            for (var _len2 = arguments.length, params = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
                params[_key2 - 1] = arguments[_key2];
            }

            return new FunctionCall(func, params);
        }
        /**
         * Creates a function call instance from its serialized representation
         * @param serialized the serialized function call
         * @returns {FunctionCall} the function call
         */

    }, {
        key: "fromSerialized",
        value: function fromSerialized(serialized) {
            return new FunctionCall(serialized.functionId, serialized.parameters);
        }
    }]);

    function FunctionCall(func, params) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FunctionCall);

        this.func = func;
        this.params = params;
    }

    return FunctionCall;
}();

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(51);
module.exports = function(fn, that, length){
  aFunction(fn);
  if(that === undefined)return fn;
  switch(length){
    case 1: return function(a){
      return fn.call(that, a);
    };
    case 2: return function(a, b){
      return fn.call(that, a, b);
    };
    case 3: return function(a, b, c){
      return fn.call(that, a, b, c);
    };
  }
  return function(/* ...args */){
    return fn.apply(that, arguments);
  };
};

/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = {};

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys       = __webpack_require__(63)
  , enumBugKeys = __webpack_require__(31);

module.exports = Object.keys || function keys(O){
  return $keys(O, enumBugKeys);
};

/***/ }),
/* 19 */
/***/ (function(module, exports) {

module.exports = function(bitmap, value){
  return {
    enumerable  : !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable    : !(bitmap & 4),
    value       : value
  };
};

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = functionId;
/* harmony export (immutable) */ __webpack_exports__["b"] = isFunctionId;
/**
 * @module parallel
 */
/** */
/**
 * Creates a function id
 * @param namespace the namespace of the id
 * @param id the unique id for this namespace
 * @returns the function id
 */
function functionId(namespace, id) {
  return {
    _______isFunctionId: true,
    identifier: namespace + "-" + id
  };
}
/**
 * Tests if the given object is a function id
 * @param obj the object to test for
 * @returns true if the object is  a function id
 */
function isFunctionId(obj) {
  return !!obj && obj._______isFunctionId === true;
}

/***/ }),
/* 21 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function(it){
  return toString.call(it).slice(8, -1);
};

/***/ }),
/* 22 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(30);
module.exports = function(it){
  return Object(defined(it));
};

/***/ }),
/* 24 */
/***/ (function(module, exports) {

var id = 0
  , px = Math.random();
module.exports = function(key){
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParallelWorkerFunctionIds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__function_function_id__ = __webpack_require__(20);

var ParallelWorkerFunctionIds = {
    FILTER: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__function_function_id__["a" /* functionId */])("parallel", 0),
    IDENTITY: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__function_function_id__["a" /* functionId */])("parallel", 1),
    MAP: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__function_function_id__["a" /* functionId */])("parallel", 2),
    PARALLEL_JOB_EXECUTOR: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__function_function_id__["a" /* functionId */])("parallel", 3),
    RANGE: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__function_function_id__["a" /* functionId */])("parallel", 4),
    REDUCE: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__function_function_id__["a" /* functionId */])("parallel", 5),
    TIMES: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__function_function_id__["a" /* functionId */])("parallel", 6),
    TO_ITERATOR: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__function_function_id__["a" /* functionId */])("parallel", 7)
};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

module.exports = true;

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(6).f
  , has = __webpack_require__(10)
  , TAG = __webpack_require__(3)('toStringTag');

module.exports = function(it, tag, stat){
  if(it && !has(it = stat ? it : it.prototype, TAG))def(it, TAG, {configurable: true, value: tag});
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at  = __webpack_require__(107)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(59)(String, 'String', function(iterated){
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , index = this._i
    , point;
  if(index >= O.length)return {value: undefined, done: true};
  point = $at(O, index);
  this._i += point.length;
  return {value: point, done: false};
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toIterator;
/* harmony export (immutable) */ __webpack_exports__["b"] = toArray;
/* harmony export (immutable) */ __webpack_exports__["c"] = flattenArray;
/* harmony export (immutable) */ __webpack_exports__["d"] = concatInPlace;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);


/**
 * Creates an iterator that iterates over the given array
 * @param data the array
 * @param T element type
 * @returns the iterator
 */
/**
 * Creates an iterator that iterates over the given array
 * @param data the array
 * @param T element type
 * @returns the iterator
 */function toIterator(data) {
    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(data);
}
/**
 * Converts the given iterator to an array
 * @param iterator the iterator that is to be converted into an array
 * @param T element type
 * @returns {T[]} the array representation of the given iterator
 */
function toArray(iterator) {
    var result = [];
    var current = void 0;
    /* tslint:disable:no-conditional-assignment */
    while (!(current = iterator.next()).done) {
        result.push(current.value);
    }
    return result;
}
/**
 * Flattens the given array.
 * @param deepArray the array to flatten
 * @param type of the array elements
 * @returns returns an array containing all the values contained in the sub arrays of deep array.
 */
function flattenArray(deepArray) {
    if (deepArray.length === 0) {
        return [];
    }

    var _deepArray = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toArray___default()(deepArray),
        head = _deepArray[0],
        tail = _deepArray.slice(1);

    return Array.prototype.concat.apply(head, tail);
}
/**
 * Appends the toAppend array to the target array. The result is stored in the target array (therefore, in place)
 * @param target the first element to concat and as well as the target of the concatenation operation
 * @param toAppend the array to append to target
 */
function concatInPlace(target, toAppend) {
    var insertionIndex = target.length;
    target.length += toAppend.length;
    for (var i = 0; i < toAppend.length; ++i) {
        target[insertionIndex + i] = toAppend[i];
    }
    return target;
}

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function(it){
  if(it == undefined)throw TypeError("Can't call method on  " + it);
  return it;
};

/***/ }),
/* 31 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject    = __webpack_require__(7)
  , dPs         = __webpack_require__(105)
  , enumBugKeys = __webpack_require__(31)
  , IE_PROTO    = __webpack_require__(34)('IE_PROTO')
  , Empty       = function(){ /* empty */ }
  , PROTOTYPE   = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function(){
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(43)('iframe')
    , i      = enumBugKeys.length
    , lt     = '<'
    , gt     = '>'
    , iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(68).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while(i--)delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties){
  var result;
  if(O !== null){
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty;
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 33 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(35)('keys')
  , uid    = __webpack_require__(24);
module.exports = function(key){
  return shared[key] || (shared[key] = uid(key));
};

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(4)
  , SHARED = '__core-js_shared__'
  , store  = global[SHARED] || (global[SHARED] = {});
module.exports = function(key){
  return store[key] || (store[key] = {});
};

/***/ }),
/* 36 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil  = Math.ceil
  , floor = Math.floor;
module.exports = function(it){
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};

/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(14);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function(it, S){
  if(!isObject(it))return it;
  var fn, val;
  if(S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  if(typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it)))return val;
  if(!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it)))return val;
  throw TypeError("Can't convert object to primitive value");
};

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var global         = __webpack_require__(4)
  , core           = __webpack_require__(2)
  , LIBRARY        = __webpack_require__(26)
  , wksExt         = __webpack_require__(39)
  , defineProperty = __webpack_require__(6).f;
module.exports = function(name){
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if(name.charAt(0) != '_' && !(name in $Symbol))defineProperty($Symbol, name, {value: wksExt.f(name)});
};

/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(3);

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isSerializedFunctionCall;
/**
 * @module parallel
 */
/** */
/**
 * Tests if the given object is a serialized function call
 * @param potentialFunc a potentially serialized function call
 * @returns {boolean} true if it is a serialized function call, false otherwise
 */
function isSerializedFunctionCall(potentialFunc) {
  return !!potentialFunc && potentialFunc.______serializedFunctionCall === true;
}

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["h"] = initializeWorkerMessage;
/* harmony export (immutable) */ __webpack_exports__["i"] = scheduleTaskMessage;
/* harmony export (immutable) */ __webpack_exports__["d"] = requestFunctionMessage;
/* harmony export (immutable) */ __webpack_exports__["n"] = functionResponseMessage;
/* harmony export (immutable) */ __webpack_exports__["g"] = workerResultMessage;
/* harmony export (immutable) */ __webpack_exports__["f"] = functionExecutionError;
/* harmony export (immutable) */ __webpack_exports__["j"] = stopMessage;
/* harmony export (immutable) */ __webpack_exports__["c"] = isScheduleTask;
/* harmony export (immutable) */ __webpack_exports__["b"] = isInitializeMessage;
/* harmony export (immutable) */ __webpack_exports__["k"] = isFunctionRequest;
/* harmony export (immutable) */ __webpack_exports__["e"] = isFunctionResponse;
/* harmony export (immutable) */ __webpack_exports__["l"] = isWorkerResult;
/* harmony export (immutable) */ __webpack_exports__["m"] = isFunctionExecutionError;
/* harmony export (immutable) */ __webpack_exports__["a"] = isStopMesssage;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);



/**
 * Creates an initialize worker message
 * @param id the unique id of the worker
 * @returns the initialize worker message
 */
function initializeWorkerMessage(id) {
    return { type: 0 /* InitializeWorker */, workerId: id };
}
/**
 * Creates a message to schedule the given task on a worker slave
 * @param task the task to schedule
 * @returns the schedule message
 */
function scheduleTaskMessage(task) {
    return { task: task, type: 1 /* ScheduleTask */ };
}
/**
 * Creates an {@link IFunctionRequest} message that requests the given function ids from the worker thread
 * @param functionId the id of a function to request
 * @param otherFunctionIds additional ids to request from the worker slave
 * @returns the function request message
 */
function requestFunctionMessage(functionId) {
    for (var _len = arguments.length, otherFunctionIds = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        otherFunctionIds[_key - 1] = arguments[_key];
    }

    return { functionIds: [functionId].concat(otherFunctionIds), type: 2 /* FunctionRequest */ };
}
/**
 * Creates a function response message containing the passed function definitions
 * @param functions the function definitions to respond to the worker slave
 * @returns the function response message
 */
function functionResponseMessage(functions) {
    for (var _len2 = arguments.length, missingFunctionIds = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        missingFunctionIds[_key2 - 1] = arguments[_key2];
    }

    return { functions: functions, missingFunctions: missingFunctionIds, type: 3 /* FunctionResponse */ };
}
/**
 * Creates a worker result message for the given result
 * @param result the computed result for the scheduled task
 * @returns the message
 */
function workerResultMessage(result) {
    return { result: result, type: 4 /* WorkerResult */ };
}
/**
 * Creates a function execution error message containing the given error
 * @param error the error object thrown by the task computation
 * @returns the message
 */
function functionExecutionError(error) {
    var errorObject = {};
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_own_property_names___default()(error)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var prop = _step.value;

            errorObject[prop] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(error[prop]);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    return { error: errorObject, type: 5 /* FunctionExecutionError */ };
}
/**
 * Creates a stop message
 * @returns the message
 */
function stopMessage() {
    return { type: 6 /* Stop */ };
}
/**
 * Tests if the given message is an {@link IScheduleTaskMessage} message
 * @param message the message to test
 * @returns {boolean} {@code true} if the message is an {@link IScheduleTaskMessage}
 */
function isScheduleTask(message) {
    return message.type === 1 /* ScheduleTask */;
}
/**
 * Tests if the given message is an {@link IInitializeWorkerMessage} message
 * @param message the message to test
 * @returns {boolean} {@code true} if the message is an {@link IInitializeWorkerMessage}
 */
function isInitializeMessage(message) {
    return message.type === 0 /* InitializeWorker */;
}
/**
 * Tests if the given message is an {@link IFunctionRequest} message
 * @param message the message to test
 * @returns {boolean} {@code true} if the message is an {@link IFunctionRequest}
 */
function isFunctionRequest(message) {
    return message.type === 2 /* FunctionRequest */;
}
/**
 * Tests if the given message is an {@link IFunctionResponse} message
 * @param message the message to test
 * @returns {boolean} {@code true} if the message is an {@link IFunctionResponse}
 */
function isFunctionResponse(message) {
    return message.type === 3 /* FunctionResponse */;
}
/**
 * Tests if the given message is an {@link IWorkerResultMessage} message
 * @param message the message to test
 * @returns {boolean} {@code true} if the message is an {@link IWorkerResultMessage}
 */
function isWorkerResult(message) {
    return message.type === 4 /* WorkerResult */;
}
/**
 * Tests if the given message is an {@link IFunctionExecutionError} message
 * @param message the message to test
 * @returns {boolean} {@code true} if the message is an {@link IFunctionExecutionError}
 */
function isFunctionExecutionError(message) {
    return message.type === 5 /* FunctionExecutionError */;
}
/**
 * Tests if the given message is a stop message
 * @param message the message to test
 * @returns {boolean} {@code true} if the message is a stop message
 */
function isStopMesssage(message) {
    return message.type === 6 /* Stop */;
}

/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(91), __esModule: true };

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(14)
  , document = __webpack_require__(4).document
  // in old IE typeof document.createElement is 'object'
  , is = isObject(document) && isObject(document.createElement);
module.exports = function(it){
  return is ? document.createElement(it) : {};
};

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var pIE            = __webpack_require__(22)
  , createDesc     = __webpack_require__(19)
  , toIObject      = __webpack_require__(9)
  , toPrimitive    = __webpack_require__(37)
  , has            = __webpack_require__(10)
  , IE8_DOM_DEFINE = __webpack_require__(57)
  , gOPD           = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(8) ? gOPD : function getOwnPropertyDescriptor(O, P){
  O = toIObject(O);
  P = toPrimitive(P, true);
  if(IE8_DOM_DEFINE)try {
    return gOPD(O, P);
  } catch(e){ /* empty */ }
  if(has(O, P))return createDesc(!pIE.f.call(O, P), O[P]);
};

/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

// most Object methods by ES6 should accept primitives
var $export = __webpack_require__(5)
  , core    = __webpack_require__(2)
  , fails   = __webpack_require__(13);
module.exports = function(KEY, exec){
  var fn  = (core.Object || {})[KEY] || Object[KEY]
    , exp = {};
  exp[KEY] = exec(fn);
  $export($export.S + $export.F * fails(function(){ fn(1); }), 'Object', exp);
};

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(36)
  , min       = Math.min;
module.exports = function(it){
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

var classof   = __webpack_require__(67)
  , ITERATOR  = __webpack_require__(3)('iterator')
  , Iterators = __webpack_require__(17);
module.exports = __webpack_require__(2).getIteratorMethod = function(it){
  if(it != undefined)return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};

/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(112);
var global        = __webpack_require__(4)
  , hide          = __webpack_require__(11)
  , Iterators     = __webpack_require__(17)
  , TO_STRING_TAG = __webpack_require__(3)('toStringTag');

for(var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++){
  var NAME       = collections[i]
    , Collection = global[NAME]
    , proto      = Collection && Collection.prototype;
  if(proto && !proto[TO_STRING_TAG])hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParallelStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scheduled_parallel_stream__ = __webpack_require__(140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__resolved_parallel_stream__ = __webpack_require__(139);






/**
 * Generic parallel stream that can be coordinated using the provided next, resolve and reject callbacks.
 * @param TSubResult type of the sub results
 * @param TEndResult type of the end result
 */
var ParallelStream = function () {
    /**
     * Creates a new, generic parallel stream
     * @param executor the executor function that gets passed the next, resolve and reject functions
     */
    function ParallelStream(executor) {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ParallelStream);

        /**
         * Registered handlers that should be called for each sub result
         * @type {Array}
         * @private
         */
        this.nextHandlers = [];
        var next = function next(subResult, worker, valuesPerWorker) {
            return _this._next(subResult, worker, valuesPerWorker);
        };
        var reject = function reject(reason) {
            return _this.reject(reason);
        };
        var resolve = function resolve(result) {
            return _this.resolve(result);
        };
        executor(next, resolve, reject);
        this.promise = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (res, rej) {
            _this.resolve = res;
            _this.reject = rej;
        });
    }
    /**
     * Creates a new parallel that is based on the given input stream but transforms the end result using the given transformer
     * @param inputStream the input stream on which the returned stream is based on
     * @param transformer the transformer used to transform the end result
     * @param TIn type of the input elements for this stream
     * @param TIntermediate type of the end results from the input stream
     * @param TResult end result after applying the transformer.
     * @returns parallel stream that is based on the given input stream but with the transformed end result
     */


    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ParallelStream, [{
        key: "subscribe",
        value: function subscribe(onNext, onError, onComplete) {
            this.nextHandlers.push(onNext);
            if (onError || onComplete) {
                this.promise.then(onComplete, onError);
            }
            return this;
        }
    }, {
        key: "then",
        value: function then(onfulfilled, onrejected) {
            return this.promise.then(onfulfilled, onrejected);
        }
    }, {
        key: "catch",
        value: function _catch(onrejected) {
            return this.promise.catch(onrejected);
        }
    }, {
        key: "_next",
        value: function _next(subResult, taskIndex, valuesPerTask) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.nextHandlers), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var nextHandler = _step.value;

                    nextHandler.apply(undefined, arguments);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    }], [{
        key: "transform",
        value: function transform(inputStream, transformer) {
            var next = void 0;
            var resolve = void 0;
            var reject = void 0;
            var transformedStream = new ParallelStream(function (nxt, rsolve, rject) {
                next = nxt;
                resolve = rsolve;
                reject = rject;
            });
            inputStream.subscribe(next, reject, function (result) {
                return resolve(transformer(result));
            });
            return transformedStream;
        }
        /**
         * Creates a new parallel stream for the given set of tasks.
         * @param tasks the set of tasks that compute the results of the stream
         * @param defaultResult the default result
         * @param joiner the joiner to use to join two computed task results
         * @param TTaskResult type of the task results
         * @param TEndResult result of the created stream. Created by applying the end results of the stream to the joiner
         * @returns stream for the given set of tasks
         */

    }, {
        key: "fromTasks",
        value: function fromTasks(tasks, defaultResult, joiner) {
            if (tasks.length === 0) {
                return new __WEBPACK_IMPORTED_MODULE_5__resolved_parallel_stream__["a" /* ResolvedParallelStream */](defaultResult);
            }
            return new __WEBPACK_IMPORTED_MODULE_4__scheduled_parallel_stream__["a" /* ScheduledParallelStream */](tasks, defaultResult, joiner);
        }
    }]);

    return ParallelStream;
}();

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(52);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports = function(it){
  if(typeof it != 'function')throw TypeError(it + ' is not a function!');
  return it;
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(84), __esModule: true };

/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(81);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(78);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(56);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(56);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(52);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
};

/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(83);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(82);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(8) && !__webpack_require__(13)(function(){
  return Object.defineProperty(__webpack_require__(43)('div'), 'a', {get: function(){ return 7; }}).a != 7;
});

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(21);
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function(it){
  return cof(it) == 'String' ? it.split('') : Object(it);
};

/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY        = __webpack_require__(26)
  , $export        = __webpack_require__(5)
  , redefine       = __webpack_require__(64)
  , hide           = __webpack_require__(11)
  , has            = __webpack_require__(10)
  , Iterators      = __webpack_require__(17)
  , $iterCreate    = __webpack_require__(100)
  , setToStringTag = __webpack_require__(27)
  , getPrototypeOf = __webpack_require__(62)
  , ITERATOR       = __webpack_require__(3)('iterator')
  , BUGGY          = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
  , FF_ITERATOR    = '@@iterator'
  , KEYS           = 'keys'
  , VALUES         = 'values';

var returnThis = function(){ return this; };

module.exports = function(Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED){
  $iterCreate(Constructor, NAME, next);
  var getMethod = function(kind){
    if(!BUGGY && kind in proto)return proto[kind];
    switch(kind){
      case KEYS: return function keys(){ return new Constructor(this, kind); };
      case VALUES: return function values(){ return new Constructor(this, kind); };
    } return function entries(){ return new Constructor(this, kind); };
  };
  var TAG        = NAME + ' Iterator'
    , DEF_VALUES = DEFAULT == VALUES
    , VALUES_BUG = false
    , proto      = Base.prototype
    , $native    = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT]
    , $default   = $native || getMethod(DEFAULT)
    , $entries   = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined
    , $anyNative = NAME == 'Array' ? proto.entries || $native : $native
    , methods, key, IteratorPrototype;
  // Fix native
  if($anyNative){
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base));
    if(IteratorPrototype !== Object.prototype){
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if(!LIBRARY && !has(IteratorPrototype, ITERATOR))hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if(DEF_VALUES && $native && $native.name !== VALUES){
    VALUES_BUG = true;
    $default = function values(){ return $native.call(this); };
  }
  // Define iterator
  if((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])){
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG]  = returnThis;
  if(DEFAULT){
    methods = {
      values:  DEF_VALUES ? $default : getMethod(VALUES),
      keys:    IS_SET     ? $default : getMethod(KEYS),
      entries: $entries
    };
    if(FORCED)for(key in methods){
      if(!(key in proto))redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};

/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(9)
  , gOPN      = __webpack_require__(61).f
  , toString  = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function(it){
  try {
    return gOPN(it);
  } catch(e){
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it){
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys      = __webpack_require__(63)
  , hiddenKeys = __webpack_require__(31).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O){
  return $keys(O, hiddenKeys);
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has         = __webpack_require__(10)
  , toObject    = __webpack_require__(23)
  , IE_PROTO    = __webpack_require__(34)('IE_PROTO')
  , ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function(O){
  O = toObject(O);
  if(has(O, IE_PROTO))return O[IE_PROTO];
  if(typeof O.constructor == 'function' && O instanceof O.constructor){
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};

/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var has          = __webpack_require__(10)
  , toIObject    = __webpack_require__(9)
  , arrayIndexOf = __webpack_require__(96)(false)
  , IE_PROTO     = __webpack_require__(34)('IE_PROTO');

module.exports = function(object, names){
  var O      = toIObject(object)
    , i      = 0
    , result = []
    , key;
  for(key in O)if(key != IE_PROTO)has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while(names.length > i)if(has(O, key = names[i++])){
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(11);

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(87), __esModule: true };

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(149), __esModule: true };

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(21)
  , TAG = __webpack_require__(3)('toStringTag')
  // ES3 wrong here
  , ARG = cof(function(){ return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function(it, key){
  try {
    return it[key];
  } catch(e){ /* empty */ }
};

module.exports = function(it){
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(4).document && document.documentElement;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators  = __webpack_require__(17)
  , ITERATOR   = __webpack_require__(3)('iterator')
  , ArrayProto = Array.prototype;

module.exports = function(it){
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(7);
module.exports = function(iterator, fn, value, entries){
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch(e){
    var ret = iterator['return'];
    if(ret !== undefined)anObject(ret.call(iterator));
    throw e;
  }
};

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR     = __webpack_require__(3)('iterator')
  , SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function(){ SAFE_CLOSING = true; };
  Array.from(riter, function(){ throw 2; });
} catch(e){ /* empty */ }

module.exports = function(exec, skipClosing){
  if(!skipClosing && !SAFE_CLOSING)return false;
  var safe = false;
  try {
    var arr  = [7]
      , iter = arr[ITERATOR]();
    iter.next = function(){ return {done: safe = true}; };
    arr[ITERATOR] = function(){ return iter; };
    exec(arr);
  } catch(e){ /* empty */ }
  return safe;
};

/***/ }),
/* 72 */
/***/ (function(module, exports) {



/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FunctionCallSerializer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


/**
 * @module parallel
 */
/** */
/**
 * Serializer for function calls
 */
var FunctionCallSerializer = function () {
  /**
   * Creates a new instances that uses the given function registry to lookup the unique id of a function
   * @param functionRegistry the registry for function lookup
   */
  function FunctionCallSerializer(functionRegistry) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FunctionCallSerializer);

    this.functionRegistry = functionRegistry;
  }
  /**
   * Serializes a call to the given function and using the passed parameters
   * @param call the function call to serialize
   * @returns a serialized representation of a call to the passed function using the given parameters
   */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FunctionCallSerializer, [{
    key: "serializeFunctionCall",
    value: function serializeFunctionCall(call) {
      var funcId = this.functionRegistry.getOrSetId(call.func);
      return {
        ______serializedFunctionCall: true,
        functionId: funcId,
        parameters: call.params
      };
    }
  }]);

  return FunctionCallSerializer;
}();

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScheduledParallelChainState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__dependent_parallel_chain_state__ = __webpack_require__(130);



/**
 * State of a parallel chain whose job has been scheduled on the thread pool (or even where the computation already has completed).
 * @param TElement type of the elements produced by the stream
 */
var ScheduledParallelChainState = function () {
    /**
     * Creates a new state that is based on the given stream
     * @param stream the stream for the scheduled tasks
     * @param options the options used for the scheduled job
     * @param environment the environment used for the scheduled job
     */
    function ScheduledParallelChainState(stream, options, environment) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ScheduledParallelChainState);

        this.options = options;
        this.environment = environment;
        this.stream = stream;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ScheduledParallelChainState, [{
        key: "resolve",
        value: function resolve() {
            return this;
        }
    }, {
        key: "chainOperation",
        value: function chainOperation(operation) {
            return new __WEBPACK_IMPORTED_MODULE_2__dependent_parallel_chain_state__["a" /* DependentParallelChainState */](this.stream, this.options, this.environment, [operation]);
        }
    }, {
        key: "addEnvironment",
        value: function addEnvironment(environment) {
            return new __WEBPACK_IMPORTED_MODULE_2__dependent_parallel_chain_state__["a" /* DependentParallelChainState */](this.stream, this.options, this.environment.add(environment));
        }
    }]);

    return ScheduledParallelChainState;
}();

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParallelCollectionGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slave_parallel_worker_functions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__function_function_call__ = __webpack_require__(15);




/**
 * Generator for arrays.
 * Splits the array elements onto separate tasks.
 * @param T type of the array elements
 */
var ParallelCollectionGenerator = function () {
    /**
     * Creates a new instance over the given collection
     * @param collection
     */
    function ParallelCollectionGenerator(collection) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ParallelCollectionGenerator);

        this.collection = collection;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ParallelCollectionGenerator, [{
        key: "serializeSlice",
        value: function serializeSlice(index, numberOfItems, functionCallSerializer) {
            var start = numberOfItems * index;
            var end = start + numberOfItems;
            return functionCallSerializer.serializeFunctionCall(__WEBPACK_IMPORTED_MODULE_3__function_function_call__["a" /* FunctionCall */].createUnchecked(__WEBPACK_IMPORTED_MODULE_2__slave_parallel_worker_functions__["a" /* ParallelWorkerFunctionIds */].TO_ITERATOR, this.collection.slice(start, end)));
        }
    }, {
        key: "length",
        get: function get() {
            return this.collection.length;
        }
    }]);

    return ParallelCollectionGenerator;
}();

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SimpleMap; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);


/**
 * A very simple implementation of a map. Do not use with complex objects as Key.
 * @param K type of the key
 * @param V type of the value
 */
/**
 * A very simple implementation of a map. Do not use with complex objects as Key.
 * @param K type of the key
 * @param V type of the value
 */var SimpleMap = function () {
    function SimpleMap() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, SimpleMap);

        this.data = {};
    }
    /**
     * Gets the value for the given key if available
     * @param key the key to look up
     * @returns the looked up value or undefined if the map does not contain any value associated with the given key
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(SimpleMap, [{
        key: "get",
        value: function get(key) {
            var internalKey = this.toInternalKey(key);
            return this.has(key) ? this.data[internalKey] : undefined;
        }
        /**
         * Tests if the map contains value stored by the given key
         * @param key the key
         * @returns true if the map contains a value by the given key, false otherwise
         */

    }, {
        key: "has",
        value: function has(key) {
            return this.hasOwnProperty.call(this.data, this.toInternalKey(key));
        }
        /**
         * Sets the value for the given key. If the map already contains a value stored by the given key, then this value is
         * overridden
         * @param key the key
         * @param value the value to associate with the given key
         */

    }, {
        key: "set",
        value: function set(key, value) {
            this.data[this.toInternalKey(key)] = value;
        }
        /**
         * Clears all values from the map
         */

    }, {
        key: "clear",
        value: function clear() {
            this.data = {};
        }
    }, {
        key: "toInternalKey",
        value: function toInternalKey(key) {
            return "@" + key;
        }
    }]);

    return SimpleMap;
}();

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(86), __esModule: true };

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(88), __esModule: true };

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(89), __esModule: true };

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(90), __esModule: true };

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(92), __esModule: true };

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(93), __esModule: true };

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(94), __esModule: true };

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
__webpack_require__(111);
module.exports = __webpack_require__(2).Array.from;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(48);
__webpack_require__(28);
module.exports = __webpack_require__(110);

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var core  = __webpack_require__(2)
  , $JSON = core.JSON || (core.JSON = {stringify: JSON.stringify});
module.exports = function stringify(it){ // eslint-disable-line no-unused-vars
  return $JSON.stringify.apply($JSON, arguments);
};

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(113);
module.exports = __webpack_require__(2).Object.assign;

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(114);
var $Object = __webpack_require__(2).Object;
module.exports = function create(P, D){
  return $Object.create(P, D);
};

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(115);
var $Object = __webpack_require__(2).Object;
module.exports = function defineProperty(it, key, desc){
  return $Object.defineProperty(it, key, desc);
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(116);
var $Object = __webpack_require__(2).Object;
module.exports = function getOwnPropertyNames(it){
  return $Object.getOwnPropertyNames(it);
};

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(117);
module.exports = __webpack_require__(2).Object.getPrototypeOf;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(118);
module.exports = __webpack_require__(2).Object.setPrototypeOf;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(119);
__webpack_require__(72);
__webpack_require__(120);
__webpack_require__(121);
module.exports = __webpack_require__(2).Symbol;

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(28);
__webpack_require__(48);
module.exports = __webpack_require__(39).f('iterator');

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = function(){ /* empty */ };

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(9)
  , toLength  = __webpack_require__(46)
  , toIndex   = __webpack_require__(109);
module.exports = function(IS_INCLUDES){
  return function($this, el, fromIndex){
    var O      = toIObject($this)
      , length = toLength(O.length)
      , index  = toIndex(fromIndex, length)
      , value;
    // Array#includes uses SameValueZero equality algorithm
    if(IS_INCLUDES && el != el)while(length > index){
      value = O[index++];
      if(value != value)return true;
    // Array#toIndex ignores holes, Array#includes - not
    } else for(;length > index; index++)if(IS_INCLUDES || index in O){
      if(O[index] === el)return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(6)
  , createDesc      = __webpack_require__(19);

module.exports = function(object, index, value){
  if(index in object)$defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};

/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(18)
  , gOPS    = __webpack_require__(33)
  , pIE     = __webpack_require__(22);
module.exports = function(it){
  var result     = getKeys(it)
    , getSymbols = gOPS.f;
  if(getSymbols){
    var symbols = getSymbols(it)
      , isEnum  = pIE.f
      , i       = 0
      , key;
    while(symbols.length > i)if(isEnum.call(it, key = symbols[i++]))result.push(key);
  } return result;
};

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(21);
module.exports = Array.isArray || function isArray(arg){
  return cof(arg) == 'Array';
};

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create         = __webpack_require__(32)
  , descriptor     = __webpack_require__(19)
  , setToStringTag = __webpack_require__(27)
  , IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(11)(IteratorPrototype, __webpack_require__(3)('iterator'), function(){ return this; });

module.exports = function(Constructor, NAME, next){
  Constructor.prototype = create(IteratorPrototype, {next: descriptor(1, next)});
  setToStringTag(Constructor, NAME + ' Iterator');
};

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = function(done, value){
  return {value: value, done: !!done};
};

/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

var getKeys   = __webpack_require__(18)
  , toIObject = __webpack_require__(9);
module.exports = function(object, el){
  var O      = toIObject(object)
    , keys   = getKeys(O)
    , length = keys.length
    , index  = 0
    , key;
  while(length > index)if(O[key = keys[index++]] === el)return key;
};

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var META     = __webpack_require__(24)('meta')
  , isObject = __webpack_require__(14)
  , has      = __webpack_require__(10)
  , setDesc  = __webpack_require__(6).f
  , id       = 0;
var isExtensible = Object.isExtensible || function(){
  return true;
};
var FREEZE = !__webpack_require__(13)(function(){
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function(it){
  setDesc(it, META, {value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  }});
};
var fastKey = function(it, create){
  // return primitive with prefix
  if(!isObject(it))return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return 'F';
    // not necessary to add metadata
    if(!create)return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function(it, create){
  if(!has(it, META)){
    // can't set metadata to uncaught frozen object
    if(!isExtensible(it))return true;
    // not necessary to add metadata
    if(!create)return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function(it){
  if(FREEZE && meta.NEED && isExtensible(it) && !has(it, META))setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY:      META,
  NEED:     false,
  fastKey:  fastKey,
  getWeak:  getWeak,
  onFreeze: onFreeze
};

/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var getKeys  = __webpack_require__(18)
  , gOPS     = __webpack_require__(33)
  , pIE      = __webpack_require__(22)
  , toObject = __webpack_require__(23)
  , IObject  = __webpack_require__(58)
  , $assign  = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(13)(function(){
  var A = {}
    , B = {}
    , S = Symbol()
    , K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function(k){ B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source){ // eslint-disable-line no-unused-vars
  var T     = toObject(target)
    , aLen  = arguments.length
    , index = 1
    , getSymbols = gOPS.f
    , isEnum     = pIE.f;
  while(aLen > index){
    var S      = IObject(arguments[index++])
      , keys   = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S)
      , length = keys.length
      , j      = 0
      , key;
    while(length > j)if(isEnum.call(S, key = keys[j++]))T[key] = S[key];
  } return T;
} : $assign;

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var dP       = __webpack_require__(6)
  , anObject = __webpack_require__(7)
  , getKeys  = __webpack_require__(18);

module.exports = __webpack_require__(8) ? Object.defineProperties : function defineProperties(O, Properties){
  anObject(O);
  var keys   = getKeys(Properties)
    , length = keys.length
    , i = 0
    , P;
  while(length > i)dP.f(O, P = keys[i++], Properties[P]);
  return O;
};

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(14)
  , anObject = __webpack_require__(7);
var check = function(O, proto){
  anObject(O);
  if(!isObject(proto) && proto !== null)throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function(test, buggy, set){
      try {
        set = __webpack_require__(16)(Function.call, __webpack_require__(44).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch(e){ buggy = true; }
      return function setPrototypeOf(O, proto){
        check(O, proto);
        if(buggy)O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(36)
  , defined   = __webpack_require__(30);
// true  -> String#at
// false -> String#codePointAt
module.exports = function(TO_STRING){
  return function(that, pos){
    var s = String(defined(that))
      , i = toInteger(pos)
      , l = s.length
      , a, b;
    if(i < 0 || i >= l)return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var ctx                = __webpack_require__(16)
  , invoke             = __webpack_require__(152)
  , html               = __webpack_require__(68)
  , cel                = __webpack_require__(43)
  , global             = __webpack_require__(4)
  , process            = global.process
  , setTask            = global.setImmediate
  , clearTask          = global.clearImmediate
  , MessageChannel     = global.MessageChannel
  , counter            = 0
  , queue              = {}
  , ONREADYSTATECHANGE = 'onreadystatechange'
  , defer, channel, port;
var run = function(){
  var id = +this;
  if(queue.hasOwnProperty(id)){
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function(event){
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if(!setTask || !clearTask){
  setTask = function setImmediate(fn){
    var args = [], i = 1;
    while(arguments.length > i)args.push(arguments[i++]);
    queue[++counter] = function(){
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id){
    delete queue[id];
  };
  // Node.js 0.8-
  if(__webpack_require__(21)(process) == 'process'){
    defer = function(id){
      process.nextTick(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if(MessageChannel){
    channel = new MessageChannel;
    port    = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if(global.addEventListener && typeof postMessage == 'function' && !global.importScripts){
    defer = function(id){
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if(ONREADYSTATECHANGE in cel('script')){
    defer = function(id){
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function(){
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function(id){
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set:   setTask,
  clear: clearTask
};

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(36)
  , max       = Math.max
  , min       = Math.min;
module.exports = function(index, length){
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(7)
  , get      = __webpack_require__(47);
module.exports = __webpack_require__(2).getIterator = function(it){
  var iterFn = get(it);
  if(typeof iterFn != 'function')throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx            = __webpack_require__(16)
  , $export        = __webpack_require__(5)
  , toObject       = __webpack_require__(23)
  , call           = __webpack_require__(70)
  , isArrayIter    = __webpack_require__(69)
  , toLength       = __webpack_require__(46)
  , createProperty = __webpack_require__(97)
  , getIterFn      = __webpack_require__(47);

$export($export.S + $export.F * !__webpack_require__(71)(function(iter){ Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike/*, mapfn = undefined, thisArg = undefined*/){
    var O       = toObject(arrayLike)
      , C       = typeof this == 'function' ? this : Array
      , aLen    = arguments.length
      , mapfn   = aLen > 1 ? arguments[1] : undefined
      , mapping = mapfn !== undefined
      , index   = 0
      , iterFn  = getIterFn(O)
      , length, result, step, iterator;
    if(mapping)mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if(iterFn != undefined && !(C == Array && isArrayIter(iterFn))){
      for(iterator = iterFn.call(O), result = new C; !(step = iterator.next()).done; index++){
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for(result = new C(length); length > index; index++){
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(95)
  , step             = __webpack_require__(101)
  , Iterators        = __webpack_require__(17)
  , toIObject        = __webpack_require__(9);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(59)(Array, 'Array', function(iterated, kind){
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function(){
  var O     = this._t
    , kind  = this._k
    , index = this._i++;
  if(!O || index >= O.length){
    this._t = undefined;
    return step(1);
  }
  if(kind == 'keys'  )return step(0, index);
  if(kind == 'values')return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(5);

$export($export.S + $export.F, 'Object', {assign: __webpack_require__(104)});

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5)
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', {create: __webpack_require__(32)});

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(5);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(8), 'Object', {defineProperty: __webpack_require__(6).f});

/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 Object.getOwnPropertyNames(O)
__webpack_require__(45)('getOwnPropertyNames', function(){
  return __webpack_require__(60).f;
});

/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject        = __webpack_require__(23)
  , $getPrototypeOf = __webpack_require__(62);

__webpack_require__(45)('getPrototypeOf', function(){
  return function getPrototypeOf(it){
    return $getPrototypeOf(toObject(it));
  };
});

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(5);
$export($export.S, 'Object', {setPrototypeOf: __webpack_require__(106).set});

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global         = __webpack_require__(4)
  , has            = __webpack_require__(10)
  , DESCRIPTORS    = __webpack_require__(8)
  , $export        = __webpack_require__(5)
  , redefine       = __webpack_require__(64)
  , META           = __webpack_require__(103).KEY
  , $fails         = __webpack_require__(13)
  , shared         = __webpack_require__(35)
  , setToStringTag = __webpack_require__(27)
  , uid            = __webpack_require__(24)
  , wks            = __webpack_require__(3)
  , wksExt         = __webpack_require__(39)
  , wksDefine      = __webpack_require__(38)
  , keyOf          = __webpack_require__(102)
  , enumKeys       = __webpack_require__(98)
  , isArray        = __webpack_require__(99)
  , anObject       = __webpack_require__(7)
  , toIObject      = __webpack_require__(9)
  , toPrimitive    = __webpack_require__(37)
  , createDesc     = __webpack_require__(19)
  , _create        = __webpack_require__(32)
  , gOPNExt        = __webpack_require__(60)
  , $GOPD          = __webpack_require__(44)
  , $DP            = __webpack_require__(6)
  , $keys          = __webpack_require__(18)
  , gOPD           = $GOPD.f
  , dP             = $DP.f
  , gOPN           = gOPNExt.f
  , $Symbol        = global.Symbol
  , $JSON          = global.JSON
  , _stringify     = $JSON && $JSON.stringify
  , PROTOTYPE      = 'prototype'
  , HIDDEN         = wks('_hidden')
  , TO_PRIMITIVE   = wks('toPrimitive')
  , isEnum         = {}.propertyIsEnumerable
  , SymbolRegistry = shared('symbol-registry')
  , AllSymbols     = shared('symbols')
  , OPSymbols      = shared('op-symbols')
  , ObjectProto    = Object[PROTOTYPE]
  , USE_NATIVE     = typeof $Symbol == 'function'
  , QObject        = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function(){
  return _create(dP({}, 'a', {
    get: function(){ return dP(this, 'a', {value: 7}).a; }
  })).a != 7;
}) ? function(it, key, D){
  var protoDesc = gOPD(ObjectProto, key);
  if(protoDesc)delete ObjectProto[key];
  dP(it, key, D);
  if(protoDesc && it !== ObjectProto)dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function(tag){
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function(it){
  return typeof it == 'symbol';
} : function(it){
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D){
  if(it === ObjectProto)$defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if(has(AllSymbols, key)){
    if(!D.enumerable){
      if(!has(it, HIDDEN))dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if(has(it, HIDDEN) && it[HIDDEN][key])it[HIDDEN][key] = false;
      D = _create(D, {enumerable: createDesc(0, false)});
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P){
  anObject(it);
  var keys = enumKeys(P = toIObject(P))
    , i    = 0
    , l = keys.length
    , key;
  while(l > i)$defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P){
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key){
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if(this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key){
  it  = toIObject(it);
  key = toPrimitive(key, true);
  if(it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key))return;
  var D = gOPD(it, key);
  if(D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key]))D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it){
  var names  = gOPN(toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META)result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it){
  var IS_OP  = it === ObjectProto
    , names  = gOPN(IS_OP ? OPSymbols : toIObject(it))
    , result = []
    , i      = 0
    , key;
  while(names.length > i){
    if(has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true))result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if(!USE_NATIVE){
  $Symbol = function Symbol(){
    if(this instanceof $Symbol)throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function(value){
      if(this === ObjectProto)$set.call(OPSymbols, value);
      if(has(this, HIDDEN) && has(this[HIDDEN], tag))this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if(DESCRIPTORS && setter)setSymbolDesc(ObjectProto, tag, {configurable: true, set: $set});
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString(){
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f   = $defineProperty;
  __webpack_require__(61).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(22).f  = $propertyIsEnumerable;
  __webpack_require__(33).f = $getOwnPropertySymbols;

  if(DESCRIPTORS && !__webpack_require__(26)){
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function(name){
    return wrap(wks(name));
  }
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Symbol: $Symbol});

for(var symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), i = 0; symbols.length > i; )wks(symbols[i++]);

for(var symbols = $keys(wks.store), i = 0; symbols.length > i; )wksDefine(symbols[i++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function(key){
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(key){
    if(isSymbol(key))return keyOf(SymbolRegistry, key);
    throw TypeError(key + ' is not a symbol!');
  },
  useSetter: function(){ setter = true; },
  useSimple: function(){ setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function(){
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({a: S}) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it){
    if(it === undefined || isSymbol(it))return; // IE8 returns string on undefined
    var args = [it]
      , i    = 1
      , replacer, $replacer;
    while(arguments.length > i)args.push(arguments[i++]);
    replacer = args[1];
    if(typeof replacer == 'function')$replacer = replacer;
    if($replacer || !isArray(replacer))replacer = function(key, value){
      if($replacer)value = $replacer.call(this, key, value);
      if(!isSymbol(value))return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(11)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);

/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('asyncIterator');

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(38)('observable');

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_os__ = __webpack_require__(129);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_os___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_os__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_function_dynamic_function_registry__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_function_function_call_serializer__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__node_worker_node_worker_thread_factory__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_thread_pool_default_thread_pool__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_parallel_parallel_impl__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_parallel_scheduling_default_parallel_scheduler__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared__ = __webpack_require__(123);
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isFunctionId", function() { return __WEBPACK_IMPORTED_MODULE_7__shared__["a"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FunctionCall", function() { return __WEBPACK_IMPORTED_MODULE_7__shared__["b"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "isSerializedFunctionCall", function() { return __WEBPACK_IMPORTED_MODULE_7__shared__["c"]; });
/* harmony namespace reexport (by provided) */ __webpack_require__.d(__webpack_exports__, "FunctionCallSerializer", function() { return __WEBPACK_IMPORTED_MODULE_7__shared__["d"]; });








var functionLookupTable = new __WEBPACK_IMPORTED_MODULE_1__common_function_dynamic_function_registry__["a" /* DynamicFunctionRegistry */]();
var maxConcurrencyLevel = __WEBPACK_IMPORTED_MODULE_0_os__["cpus"]().length;
var functionCallSerializer = new __WEBPACK_IMPORTED_MODULE_2__common_function_function_call_serializer__["a" /* FunctionCallSerializer */](functionLookupTable);
var threadPool = new __WEBPACK_IMPORTED_MODULE_4__common_thread_pool_default_thread_pool__["a" /* DefaultThreadPool */](new __WEBPACK_IMPORTED_MODULE_3__node_worker_node_worker_thread_factory__["a" /* NodeWorkerThreadFactory */](functionLookupTable), { maxConcurrencyLevel: maxConcurrencyLevel });
/**
 * The global parallel instance.
 */
var parallel = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__common_parallel_parallel_impl__["a" /* parallelFactory */])({
    functionCallSerializer: functionCallSerializer,
    scheduler: new __WEBPACK_IMPORTED_MODULE_6__common_parallel_scheduling_default_parallel_scheduler__["a" /* DefaultParallelScheduler */](),
    threadPool: threadPool
});
/* harmony default export */ __webpack_exports__["default"] = (parallel);

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_function_function_id__ = __webpack_require__(20);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__common_function_function_id__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_function_function_call__ = __webpack_require__(15);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__common_function_function_call__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_function_serialized_function_call__ = __webpack_require__(40);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__common_function_serialized_function_call__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_function_function_call_serializer__ = __webpack_require__(73);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__common_function_function_call_serializer__["a"]; });





/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DynamicFunctionRegistry; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_simple_map__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__function_id__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_function_name__ = __webpack_require__(142);





/**
 * Lookup table for resolving dynamic functions and their definitions
 */
var DynamicFunctionRegistry = function () {
    function DynamicFunctionRegistry() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DynamicFunctionRegistry);

        this.ids = new __WEBPACK_IMPORTED_MODULE_2__util_simple_map__["a" /* SimpleMap */]();
        this.definitions = new __WEBPACK_IMPORTED_MODULE_2__util_simple_map__["a" /* SimpleMap */]();
        this.lastId = 0;
    }
    /**
     * Returns the unique id for the passed in function or assigns a new id to the given function and returns the newly assigned id
     * @param func the function for which the unique id should be determined
     * @returns  the id of this function
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DynamicFunctionRegistry, [{
        key: "getOrSetId",
        value: function getOrSetId(func) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__function_id__["b" /* isFunctionId */])(func)) {
                return func;
            }
            var source = func.toString();
            var identifier = this.ids.get(source);
            if (typeof identifier === "undefined") {
                identifier = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__function_id__["a" /* functionId */])("dynamic", ++this.lastId);
                this.initDefinition(func, identifier);
            }
            return identifier;
        }
        /**
         * Returns the definition of the function with the given id or undefined, if the id is not assigned to any function definition
         * @param id the id of the function to resolve
         * @returns the resolved function definition or undefined
         * @throws if the function is a static function and therefore no definition exists.
         */

    }, {
        key: "getDefinition",
        value: function getDefinition(id) {
            return this.definitions.get(id.identifier);
        }
    }, {
        key: "initDefinition",
        value: function initDefinition(func, id) {
            var source = func.toString();
            var name = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_function_name__["a" /* getFunctionName */])(func);
            var args = source.substring(source.indexOf("(") + 1, source.indexOf(")")).split(",");
            var body = source.substring(source.indexOf("{") + 1, source.lastIndexOf("}")).trim();
            var definition = {
                argumentNames: args.map(function (arg) {
                    return arg.trim();
                }),
                body: body,
                id: id,
                name: name ? name : undefined
            };
            this.ids.set(source, id);
            this.definitions.set(id.identifier, definition);
        }
    }]);

    return DynamicFunctionRegistry;
}();

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parallelFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parallel_options__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__generator_parallel_collection_generator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__generator_parallel_range_generator__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__generator_parallel_times_generator__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__chain_parallel_chain_factory__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__function_function_id__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__function_function_call__ = __webpack_require__(15);









function parallelFactory(_defaultOptions) {
    function mergeOptions(userOptions) {
        if (userOptions) {
            if (userOptions.hasOwnProperty("threadPool") && typeof userOptions.threadPool === "undefined") {
                throw new Error("The thread pool is mandatory and cannot be unset");
            }
            if (userOptions.hasOwnProperty("functionCallSerializer") && typeof userOptions.functionCallSerializer === "undefined") {
                throw new Error("The function call serializer is mandatory and cannot be unset");
            }
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__parallel_options__["a" /* validateOptions */])(userOptions);
        }
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _defaultOptions, userOptions);
    }
    return {
        defaultOptions: function defaultOptions(options) {
            if (options) {
                _defaultOptions = mergeOptions(options);
            } else {
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _defaultOptions);
            }
        },
        from: function from(collection, options) {
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chain_parallel_chain_factory__["a" /* createParallelChain */])(new __WEBPACK_IMPORTED_MODULE_2__generator_parallel_collection_generator__["a" /* ParallelCollectionGenerator */](collection), mergeOptions(options));
        },
        range: function range(start, end, step, options) {
            var generator = __WEBPACK_IMPORTED_MODULE_3__generator_parallel_range_generator__["a" /* ParallelRangeGenerator */].create(start, end, step);
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chain_parallel_chain_factory__["a" /* createParallelChain */])(generator, mergeOptions(options));
        },
        times: function times(n, generator, env, options) {
            if (env) {
                return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chain_parallel_chain_factory__["a" /* createParallelChain */])(__WEBPACK_IMPORTED_MODULE_4__generator_parallel_times_generator__["a" /* ParallelTimesGenerator */].create(n, generator), mergeOptions(options), env);
            }
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__chain_parallel_chain_factory__["a" /* createParallelChain */])(__WEBPACK_IMPORTED_MODULE_4__generator_parallel_times_generator__["a" /* ParallelTimesGenerator */].create(n, generator), mergeOptions(options));
        },
        run: function run(func) {
            var functionCall = void 0;

            for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                params[_key - 1] = arguments[_key];
            }

            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_6__function_function_id__["b" /* isFunctionId */])(func)) {
                functionCall = __WEBPACK_IMPORTED_MODULE_7__function_function_call__["a" /* FunctionCall */].create(func, params);
            } else {
                functionCall = __WEBPACK_IMPORTED_MODULE_7__function_function_call__["a" /* FunctionCall */].create(func, params);
            }
            var serializedCall = _defaultOptions.functionCallSerializer.serializeFunctionCall(functionCall);
            var task = {
                main: serializedCall,
                usedFunctionIds: [serializedCall.functionId]
            };
            return _defaultOptions.threadPool.run(task);
        }
    };
}

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultParallelScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__abstract_parallel_scheduler__ = __webpack_require__(138);






/**
 * Default implementation of a parallel scheduler.
 * By default, creates 4 times as many tasks as the hardware concurrency allows ({@link IParallelOptions.maxConcurrencyLevel}).
 *
 * If the options define {@link IParallelOptions.maxValuesPerTask} or {@link IParallelOptions.minValuesPerTask}, then the
 * values are adjusted accordingly.
 */
var DefaultParallelScheduler = function (_AbstractParallelSche) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(DefaultParallelScheduler, _AbstractParallelSche);

    function DefaultParallelScheduler() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DefaultParallelScheduler);

        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DefaultParallelScheduler.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(DefaultParallelScheduler)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DefaultParallelScheduler, [{
        key: "getScheduling",
        value: function getScheduling(totalNumberOfValues, options) {
            var maxDegreeOfParallelism = void 0;
            if (options.maxDegreeOfParallelism) {
                maxDegreeOfParallelism = options.maxDegreeOfParallelism;
            } else {
                maxDegreeOfParallelism = options.threadPool.maxThreads * 4;
            }
            var valuesPerTask = totalNumberOfValues / maxDegreeOfParallelism;
            if (options.minValuesPerTask) {
                valuesPerTask = Math.min(Math.max(valuesPerTask, options.minValuesPerTask), totalNumberOfValues);
            }
            if (options.maxValuesPerTask) {
                valuesPerTask = Math.min(valuesPerTask, options.maxValuesPerTask);
            }
            valuesPerTask = Math.ceil(valuesPerTask);
            return {
                numberOfTasks: valuesPerTask === 0 ? 0 : Math.ceil(totalNumberOfValues / valuesPerTask),
                valuesPerTask: valuesPerTask
            };
        }
    }]);

    return DefaultParallelScheduler;
}(__WEBPACK_IMPORTED_MODULE_5__abstract_parallel_scheduler__["a" /* AbstractParallelScheduler */]);

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultThreadPool; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__task_worker_task__ = __webpack_require__(141);



/**
 * Default thread pool implementation that processes the scheduled functions in FIFO order.
 */
var DefaultThreadPool = function () {
    function DefaultThreadPool(workerThreadFactory, options) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DefaultThreadPool);

        this.workerThreadFactory = workerThreadFactory;
        this.workers = [];
        this.idleWorkers = [];
        this.queue = [];
        this.maxThreadsLimit = options.maxConcurrencyLevel;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DefaultThreadPool, [{
        key: "run",
        value: function run(taskDefinition) {
            var task = new __WEBPACK_IMPORTED_MODULE_2__task_worker_task__["a" /* WorkerTask */](taskDefinition);
            this.queue.unshift(task);
            this.schedulePendingTasks();
            return task;
        }
        /**
         * Schedules the tasks in the queue onto the available workers.
         * A new worker is spawned when no more idle workers are available and the number of workers has not yet reached the concurrency limit.
         * If no more idle workers are available and the concurrency limit has been reached then the tasks are left in queue.
         */

    }, {
        key: "schedulePendingTasks",
        value: function schedulePendingTasks() {
            while (this.queue.length) {
                var worker = void 0;
                if (this.idleWorkers.length === 0 && this.workers.length < this.maxThreadsLimit) {
                    worker = this.workerThreadFactory.spawn();
                    this.workers.push(worker);
                } else if (this.idleWorkers.length > 0) {
                    worker = this.idleWorkers.pop();
                }
                if (!worker) {
                    return;
                }
                var task = this.queue.pop();
                this.runTaskOnWorker(task, worker);
            }
        }
        /**
         * Starts the given task on the given worker. Resolves the task when the computation succeeds, rejects it otherwise.
         * The task is resolved when the computation has succeeded or is rejected if the computation failed
         * @param task the task to run on the given worker
         * @param worker the worker to use to execute the task
         */

    }, {
        key: "runTaskOnWorker",
        value: function runTaskOnWorker(task, worker) {
            var _this = this;

            if (task.isCancellationRequested) {
                task.resolveCancelled();
                this.releaseWorker(worker);
            } else {
                worker.run(task.definition, function (error, result) {
                    if (error) {
                        task.reject(error);
                    } else {
                        task.resolve(result);
                    }
                    _this.releaseWorker(worker);
                });
            }
        }
    }, {
        key: "releaseWorker",
        value: function releaseWorker(worker) {
            this.idleWorkers.push(worker);
            this.schedulePendingTasks();
        }
    }, {
        key: "maxThreads",
        get: function get() {
            return this.maxThreadsLimit;
        },
        set: function set(limit) {
            if (typeof limit !== "number" || limit % 1 !== 0 || limit <= 0) {
                throw new Error("The maxThreads limit (" + limit + ") has to be a positive integer larger than zero.");
            }
            this.maxThreadsLimit = limit;
        }
    }]);

    return DefaultThreadPool;
}();

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return NodeWorkerThreadFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_child_process__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_child_process___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_child_process__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_worker_default_worker_thread__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__child_process_worker_thread_slave_communication_channel__ = __webpack_require__(145);





var NodeWorkerThreadFactory = function () {
    function NodeWorkerThreadFactory(functionLookupTable) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, NodeWorkerThreadFactory);

        this.functionLookupTable = functionLookupTable;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(NodeWorkerThreadFactory, [{
        key: "spawn",
        value: function spawn() {
            var child = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2_child_process__["fork"])(this.getSlaveFileName());
            var workerThread = new __WEBPACK_IMPORTED_MODULE_3__common_worker_default_worker_thread__["a" /* DefaultWorkerThread */](this.functionLookupTable, new __WEBPACK_IMPORTED_MODULE_4__child_process_worker_thread_slave_communication_channel__["a" /* ChildProcessWorkerThreadSlaveCommunicationChannel */](child));
            workerThread.initialize();
            return workerThread;
        }
        /**
         * Hackedy Hack... Issue is, webpack handles calls to require resolve and replaces the call with the module id
         * but that's not what we want. We actually want the require resolve call to be left until execution.
         * NoParse is neither an option because then no requires / imports are resolved
         * @returns {string} the file name of the slave
         */

    }, {
        key: "getSlaveFileName",
        value: function getSlaveFileName() {
            return eval("require").resolve("./node-slave.parallel");
        }
    }]);

    return NodeWorkerThreadFactory;
}();

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports = require("os");

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DependentParallelChainState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scheduled_parallel_chain_state__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__generator_parallel_collection_generator__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_arrays__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stream_parallel_stream_impl__ = __webpack_require__(49);







/**
 * The state of a parallel chain if additional operations should be performed on an already scheduled parallel chain.
 *
 * The state needs to wait for the previous parallel job to complete and then take that result to continue the additional
 * computations.
 *
 * @param TPrevious Type of the array elements of the dependent stream
 * @param TElement Type of the array elements of the resulting array
 */
var DependentParallelChainState = function () {
    /**
     * Creates a new dependent stream
     * @param previousStream the stream upon which the new stream depends on
     * @param options the options used by this parallel job
     * @param environment the environment used by the job
     * @param operations the operations to performed when the previous stream has completed
     */
    function DependentParallelChainState(previousStream, options, environment) {
        var operations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, DependentParallelChainState);

        this.previousStream = previousStream;
        this.options = options;
        this.environment = environment;
        this.operations = operations;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DependentParallelChainState, [{
        key: "resolve",
        value: function resolve() {
            var _this = this;

            var next = void 0;
            var resolve = void 0;
            var reject = void 0;
            var stream = new __WEBPACK_IMPORTED_MODULE_6__stream_parallel_stream_impl__["a" /* ParallelStream */](function (nxt, rsolve, rject) {
                next = nxt;
                resolve = rsolve;
                reject = rject;
            });
            this.previousStream.then(function (result) {
                var tasks = _this.options.scheduler.schedule({
                    environment: _this.environment,
                    generator: new __WEBPACK_IMPORTED_MODULE_4__generator_parallel_collection_generator__["a" /* ParallelCollectionGenerator */](result),
                    operations: _this.operations,
                    options: _this.options
                });
                var wrappedStream = __WEBPACK_IMPORTED_MODULE_6__stream_parallel_stream_impl__["a" /* ParallelStream */].fromTasks(tasks, [], __WEBPACK_IMPORTED_MODULE_5__util_arrays__["d" /* concatInPlace */]);
                wrappedStream.subscribe(next, reject, resolve);
            }, reject);
            return new __WEBPACK_IMPORTED_MODULE_3__scheduled_parallel_chain_state__["a" /* ScheduledParallelChainState */](stream, this.options, this.environment);
        }
    }, {
        key: "chainOperation",
        value: function chainOperation(operation) {
            return new DependentParallelChainState(this.previousStream, this.options, this.environment, [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.operations), [operation]));
        }
    }, {
        key: "addEnvironment",
        value: function addEnvironment(environment) {
            return new DependentParallelChainState(this.previousStream, this.options, this.environment.add(environment), this.operations);
        }
    }]);

    return DependentParallelChainState;
}();

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createParallelChain;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pending_parallel_chain_state__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__parallel_chain_impl__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__parallel_environment_definition__ = __webpack_require__(136);



function createParallelChain(generator, options, sharedEnv) {
    var operations = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    var environment = void 0;
    if (sharedEnv instanceof Array) {
        environment = undefined;
        operations = sharedEnv;
    } else {
        environment = sharedEnv;
    }
    var chain = new __WEBPACK_IMPORTED_MODULE_1__parallel_chain_impl__["a" /* ParallelChainImpl */](new __WEBPACK_IMPORTED_MODULE_0__pending_parallel_chain_state__["a" /* PendingParallelChainState */](generator, options, __WEBPACK_IMPORTED_MODULE_2__parallel_environment_definition__["a" /* ParallelEnvironmentDefinition */].of(), operations));
    return environment ? chain.inEnvironment(environment) : chain;
}

/***/ }),
/* 132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParallelChainImpl; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__slave_parallel_worker_functions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__function_function_call__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__stream_parallel_stream_impl__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__function_function_id__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__function_serialized_function_call__ = __webpack_require__(40);









/**
 * Implementation of a {@link IParallelChain}
 *
 * The implementation uses an internal state ({@link IParallelChainState}) to distinguishes between a not yet scheduled job ({@link PendingParallelChainState}),
 * a job that has been scheduled but potentially not yet completed ({@link ScheduledParallelChainState}) and a job that
 * is waiting for another one to complete, but has not yet been scheduled ({@link DependentParallelChainState}).
 *
 * @param TIn type of the elements created by the generator
 * @param TEnv type of the job environment
 * @param TOut type of the elements in the resulting array
 */
var ParallelChainImpl = function () {
    /**
     * Creates a new parallel chain with the given state
     * @param state the state of the chain
     */
    function ParallelChainImpl(state) {
        __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ParallelChainImpl);

        this.state = state;
    }
    // region Chaining


    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ParallelChainImpl, [{
        key: "inEnvironment",
        value: function inEnvironment(newEnv) {
            var env = void 0;
            if (typeof newEnv === "function" || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__function_function_id__["b" /* isFunctionId */])(newEnv)) {
                for (var _len = arguments.length, params = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
                    params[_key - 1] = arguments[_key];
                }

                env = __WEBPACK_IMPORTED_MODULE_5__function_function_call__["a" /* FunctionCall */].createUnchecked.apply(__WEBPACK_IMPORTED_MODULE_5__function_function_call__["a" /* FunctionCall */], [newEnv].concat(params));
            } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__function_serialized_function_call__["a" /* isSerializedFunctionCall */])(newEnv)) {
                env = __WEBPACK_IMPORTED_MODULE_5__function_function_call__["a" /* FunctionCall */].fromSerialized(newEnv);
            } else {
                env = newEnv;
            }
            return new ParallelChainImpl(this.state.addEnvironment(env));
        }
    }, {
        key: "map",
        value: function map(mapper) {
            return this._chain(__WEBPACK_IMPORTED_MODULE_5__function_function_call__["a" /* FunctionCall */].createUnchecked(__WEBPACK_IMPORTED_MODULE_4__slave_parallel_worker_functions__["a" /* ParallelWorkerFunctionIds */].MAP), __WEBPACK_IMPORTED_MODULE_5__function_function_call__["a" /* FunctionCall */].createUnchecked(mapper));
        }
    }, {
        key: "reduce",
        value: function reduce(defaultValue, accumulator, combiner) {
            var combineOperation = combiner || accumulator;
            var reduced = this._chain(__WEBPACK_IMPORTED_MODULE_5__function_function_call__["a" /* FunctionCall */].createUnchecked(__WEBPACK_IMPORTED_MODULE_4__slave_parallel_worker_functions__["a" /* ParallelWorkerFunctionIds */].REDUCE, defaultValue), __WEBPACK_IMPORTED_MODULE_5__function_function_call__["a" /* FunctionCall */].createUnchecked(accumulator)).resolveChain();
            return __WEBPACK_IMPORTED_MODULE_6__stream_parallel_stream_impl__["a" /* ParallelStream */].transform(reduced, function (subResults) {
                if (subResults.length === 0) {
                    return defaultValue;
                }

                var _subResults = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toArray___default()(subResults),
                    head = _subResults[0],
                    tail = _subResults.slice(1);

                var sum = head;
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(tail), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var temp = _step.value;

                        sum = combineOperation(sum, temp);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }

                return sum;
            });
        }
    }, {
        key: "filter",
        value: function filter(predicate) {
            return this._chain(__WEBPACK_IMPORTED_MODULE_5__function_function_call__["a" /* FunctionCall */].createUnchecked(__WEBPACK_IMPORTED_MODULE_4__slave_parallel_worker_functions__["a" /* ParallelWorkerFunctionIds */].FILTER), __WEBPACK_IMPORTED_MODULE_5__function_function_call__["a" /* FunctionCall */].createUnchecked(predicate));
        }
        // endregion
        // region Resolving

    }, {
        key: "subscribe",
        value: function subscribe(onNext, onError, onComplete) {
            return this.resolveChain().subscribe(onNext, onError, onComplete);
        }
    }, {
        key: "then",
        value: function then(onfulfilled, onrejected) {
            return this.resolveChain().then(onfulfilled, onrejected);
        }
    }, {
        key: "catch",
        value: function _catch(onrejected) {
            return this.resolveChain().catch(onrejected);
        }
    }, {
        key: "resolveChain",
        value: function resolveChain() {
            var resolvedState = this.state = this.state.resolve();
            return resolvedState.stream;
        }
        // endregion

    }, {
        key: "_chain",
        value: function _chain(iterator, iteratee) {
            var operation = { iterator: iterator, iteratee: iteratee };
            return new ParallelChainImpl(this.state.chainOperation(operation));
        }
    }]);

    return ParallelChainImpl;
}();

/***/ }),
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PendingParallelChainState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scheduled_parallel_chain_state__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__stream_parallel_stream_impl__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_arrays__ = __webpack_require__(29);






/**
 * Parallel chain has been defined but not yet scheduled.
 *
 * The chain has been created by the user, but non terminating function (reduce, then, catch...) has been called yet.
 * @param TElement type of the elements
 */
var PendingParallelChainState = function () {
    /**
     * Creates a new state
     * @param generator the generator to use to generate the input elements and split the job
     * @param options the options
     * @param environment the environment builder that is used to create the environment for the job
     * @param operations the operations to perform on the input elements
     */
    function PendingParallelChainState(generator, options, environment, operations) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, PendingParallelChainState);

        this.generator = generator;
        this.options = options;
        this.environment = environment;
        this.operations = operations;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(PendingParallelChainState, [{
        key: "resolve",
        value: function resolve() {
            var tasks = this.options.scheduler.schedule({
                environment: this.environment,
                generator: this.generator,
                operations: this.operations,
                options: this.options
            });
            return new __WEBPACK_IMPORTED_MODULE_3__scheduled_parallel_chain_state__["a" /* ScheduledParallelChainState */](__WEBPACK_IMPORTED_MODULE_4__stream_parallel_stream_impl__["a" /* ParallelStream */].fromTasks(tasks, [], __WEBPACK_IMPORTED_MODULE_5__util_arrays__["d" /* concatInPlace */]), this.options, this.environment);
        }
    }, {
        key: "chainOperation",
        value: function chainOperation(operation) {
            return new PendingParallelChainState(this.generator, this.options, this.environment, [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.operations), [operation]));
        }
    }, {
        key: "addEnvironment",
        value: function addEnvironment(environment) {
            return new PendingParallelChainState(this.generator, this.options, this.environment.add(environment), this.operations);
        }
    }]);

    return PendingParallelChainState;
}();

/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParallelRangeGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slave_parallel_worker_functions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__function_function_call__ = __webpack_require__(15);




/**
 * Generator for creating values inside of a range
 */
var ParallelRangeGenerator = function () {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ParallelRangeGenerator, null, [{
        key: "create",

        /**
         * Creates a new parallel generator
         * @param start depends on the number of arguments. If called with one argument, then it is the end of the range and start is initialized with 0.
         * If called with two or more, then it defines the start of the range.
         * @param end defines the end of the range
         * @param step defines the step size. By default 1 if start < end and -1 if start > end.
         * @throws If step is equal to 0
         */
        value: function create(start, end, step) {
            if (typeof end === "undefined") {
                end = start;
                start = 0;
            }
            if (typeof step === "undefined") {
                step = end < start ? -1 : 1;
            }
            if (step === 0) {
                throw new Error("Step size of zero is not allowed");
            }
            return new ParallelRangeGenerator(start, end, step);
        }
    }]);

    function ParallelRangeGenerator(start, end, step) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ParallelRangeGenerator);

        this.start = start;
        this.end = end;
        this.step = step;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ParallelRangeGenerator, [{
        key: "serializeSlice",
        value: function serializeSlice(index, numberOfItems, functionCallSerializer) {
            var sliceSize = numberOfItems * this.step;
            var sliceStart = this.start + index * sliceSize;
            var sliceEnd = Math.min(sliceStart + sliceSize, this.end);
            return functionCallSerializer.serializeFunctionCall(__WEBPACK_IMPORTED_MODULE_3__function_function_call__["a" /* FunctionCall */].createUnchecked(__WEBPACK_IMPORTED_MODULE_2__slave_parallel_worker_functions__["a" /* ParallelWorkerFunctionIds */].RANGE, sliceStart, sliceEnd, this.step));
        }
    }, {
        key: "length",
        get: function get() {
            return Math.ceil((this.end - this.start) / this.step);
        }
    }]);

    return ParallelRangeGenerator;
}();

/***/ }),
/* 135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParallelTimesGenerator; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__slave_parallel_worker_functions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__function_function_call__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__function_function_id__ = __webpack_require__(20);





/**
 * Generic generator that calls a passed in function n times to create n values
 */
var ParallelTimesGenerator = function () {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ParallelTimesGenerator, null, [{
        key: "create",
        value: function create(n, generator) {
            var generatorFunction = void 0;
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__function_function_id__["b" /* isFunctionId */])(generator) || typeof generator === "function") {
                generatorFunction = __WEBPACK_IMPORTED_MODULE_3__function_function_call__["a" /* FunctionCall */].createUnchecked(generator);
            } else {
                generatorFunction = __WEBPACK_IMPORTED_MODULE_3__function_function_call__["a" /* FunctionCall */].create(__WEBPACK_IMPORTED_MODULE_2__slave_parallel_worker_functions__["a" /* ParallelWorkerFunctionIds */].IDENTITY, generator);
            }
            return new ParallelTimesGenerator(n, generatorFunction);
        }
        /**
         * Creates a new times generator that repeats the value generated by the iteratee n times.
         * @param n the number of times the value should be repeated
         * @param iteratee function that is called n times and generates the value or a constant value that is repeated
         */

    }]);

    function ParallelTimesGenerator(n, iteratee) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ParallelTimesGenerator);

        this.times = n;
        this.iteratee = iteratee;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ParallelTimesGenerator, [{
        key: "serializeSlice",
        value: function serializeSlice(index, numberOfItems, functionCallSerializer) {
            var sliceStart = index * numberOfItems;
            var sliceEnd = Math.min(sliceStart + numberOfItems, this.times);
            var iterateeFunction = functionCallSerializer.serializeFunctionCall(this.iteratee);
            return functionCallSerializer.serializeFunctionCall(__WEBPACK_IMPORTED_MODULE_3__function_function_call__["a" /* FunctionCall */].create(__WEBPACK_IMPORTED_MODULE_2__slave_parallel_worker_functions__["a" /* ParallelWorkerFunctionIds */].TIMES, sliceStart, sliceEnd, iterateeFunction));
        }
    }, {
        key: "length",
        get: function get() {
            return this.times;
        }
    }]);

    return ParallelTimesGenerator;
}();

/***/ }),
/* 136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ParallelEnvironmentDefinition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__function_function_call__ = __webpack_require__(15);




/**
 * Defines the environment for a parallel chain. The environment can consist of one or multiple static environments or
 * environments created by using an environment provider. The environments are merged in the order they have been added
 * to the parallel chain, meaning that later environments override the properties of earlier environments.
 * The implementation tries to minimize the number of environment variables to transfer by merging the environments as much
 * as possible while still maintaining the sequential order of the environments.
 */
var ParallelEnvironmentDefinition = function () {
    function ParallelEnvironmentDefinition() {
        var environments = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ParallelEnvironmentDefinition);

        this.environments = environments;
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ParallelEnvironmentDefinition, [{
        key: "add",

        /**
         * Adds the given environment
         *
         * The operation tries to keep the operation chain to a minimal in length. If two subsequent environments are
         * not providers, then the definitions are merged.
         * @param environment the new environment to add
         * @returns {ParallelEnvironmentDefinition} the new parallel environment resulting from adding the passed in environment
         * to the existing one
         */
        value: function add(environment) {
            var newEnvironments = this.environments.slice();
            if (!(environment instanceof __WEBPACK_IMPORTED_MODULE_3__function_function_call__["a" /* FunctionCall */]) && this.environments.length > 0 && !(this.environments[this.environments.length - 1] instanceof __WEBPACK_IMPORTED_MODULE_3__function_function_call__["a" /* FunctionCall */])) {
                newEnvironments[newEnvironments.length - 1] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, newEnvironments[newEnvironments.length - 1], environment);
            } else {
                newEnvironments.push(environment);
            }
            return new ParallelEnvironmentDefinition(newEnvironments);
        }
    }, {
        key: "toJSON",
        value: function toJSON(functionCallSerializer) {
            return this.environments.map(function (environment) {
                if (environment instanceof __WEBPACK_IMPORTED_MODULE_3__function_function_call__["a" /* FunctionCall */]) {
                    return functionCallSerializer.serializeFunctionCall(environment);
                }
                return environment;
            });
        }
    }], [{
        key: "of",
        value: function of(environment) {
            var definition = ParallelEnvironmentDefinition.EMPTY;
            if (environment) {
                return definition.add(environment);
            }
            return definition;
        }
    }]);

    return ParallelEnvironmentDefinition;
}();
ParallelEnvironmentDefinition.EMPTY = new ParallelEnvironmentDefinition();

/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = validateOptions;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);

/**
 * @module parallel
 */
/** needed, typedoc issue */
var greaterThanZeroOptions = ["maxValuesPerTask", "minValuesPerTask", "maxDegreeOfParallelism"];
function validateOptions(options) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
        for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(greaterThanZeroOptions), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var optionName = _step.value;

            var optionValue = options[optionName];
            if (typeof optionValue !== "undefined" && (typeof optionValue !== "number" || optionValue <= 0 || optionValue % 1 !== 0)) {
                throw new Error("Illegal parallel options: " + optionName + " (" + optionValue + ") has to be an integer greater than zero");
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally {
        try {
            if (!_iteratorNormalCompletion && _iterator.return) {
                _iterator.return();
            }
        } finally {
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }

    if (typeof options.minValuesPerTask !== "undefined" && typeof options.maxValuesPerTask !== "undefined" && options.minValuesPerTask > options.maxValuesPerTask) {
        throw new Error("Illegal parallel options: minValuesPerTask (" + options.minValuesPerTask + ") must be equal or less than maxValuesPerTask (" + options.maxValuesPerTask + ").");
    }
}

/***/ }),
/* 138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AbstractParallelScheduler; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__function_function_call__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slave_parallel_worker_functions__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__util_arrays__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__function_serialized_function_call__ = __webpack_require__(40);






var AbstractParallelScheduler = function () {
    function AbstractParallelScheduler() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AbstractParallelScheduler);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AbstractParallelScheduler, [{
        key: "schedule",
        value: function schedule(job) {
            var taskDefinitions = this.getTaskDefinitions(job);
            return taskDefinitions.map(function (taskDefinition) {
                return job.options.threadPool.run(taskDefinition);
            });
        }
    }, {
        key: "getTaskDefinitions",
        value: function getTaskDefinitions(job) {
            var scheduling = this.getScheduling(job.generator.length, job.options);
            var functionCallSerializer = job.options.functionCallSerializer;
            var environments = job.environment.toJSON(functionCallSerializer);
            var operations = this.serializeOperations(job.operations, functionCallSerializer);
            var commonFunctionIds = [__WEBPACK_IMPORTED_MODULE_3__slave_parallel_worker_functions__["a" /* ParallelWorkerFunctionIds */].PARALLEL_JOB_EXECUTOR].concat(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_4__util_arrays__["c" /* flattenArray */])(operations.map(function (operation) {
                return [operation.iteratee.functionId, operation.iterator.functionId];
            })));
            environments.forEach(function (provider) {
                if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_5__function_serialized_function_call__["a" /* isSerializedFunctionCall */])(provider)) {
                    commonFunctionIds.push(provider.functionId);
                }
            });
            var taskDefinitions = [];
            for (var i = 0; i < scheduling.numberOfTasks; ++i) {
                var generator = job.generator.serializeSlice(i, scheduling.valuesPerTask, functionCallSerializer);
                var processParams = {
                    environments: environments,
                    generator: generator,
                    operations: operations,
                    taskIndex: i,
                    valuesPerTask: scheduling.valuesPerTask
                };
                var taskDefinition = {
                    main: functionCallSerializer.serializeFunctionCall(__WEBPACK_IMPORTED_MODULE_2__function_function_call__["a" /* FunctionCall */].createUnchecked(__WEBPACK_IMPORTED_MODULE_3__slave_parallel_worker_functions__["a" /* ParallelWorkerFunctionIds */].PARALLEL_JOB_EXECUTOR, processParams)),
                    taskIndex: i,
                    usedFunctionIds: [generator.functionId].concat(commonFunctionIds),
                    valuesPerTask: scheduling.valuesPerTask
                };
                taskDefinitions.push(taskDefinition);
            }
            return taskDefinitions;
        }
    }, {
        key: "serializeOperations",
        value: function serializeOperations(operations, functionCallSerializer) {
            return operations.map(function (operation) {
                return {
                    iteratee: functionCallSerializer.serializeFunctionCall(operation.iteratee),
                    iterator: functionCallSerializer.serializeFunctionCall(operation.iterator)
                };
            });
        }
    }]);

    return AbstractParallelScheduler;
}();

/***/ }),
/* 139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ResolvedParallelStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



/**
 * Parallel stream for a static, already resolved result.
 *
 * This stream has no sub results as the end result is already known. It can also never fail.
 */
var ResolvedParallelStream = function () {
    /**
     * Creates a new stream that returns the given end result.
     * @param result the end result to return
     */
    function ResolvedParallelStream(result) {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ResolvedParallelStream);

        this.promise = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(result);
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ResolvedParallelStream, [{
        key: "subscribe",
        value: function subscribe(onNext, onError, onComplete) {
            if (onComplete || onError) {
                this.promise.then(onComplete, onError);
            }
            return this;
        }
    }, {
        key: "then",
        value: function then(onfulfilled, onrejected) {
            return this.promise.then(onfulfilled, onrejected);
        }
    }, {
        key: "catch",
        value: function _catch(onrejected) {
            return this.promise.catch(onrejected);
        }
    }]);

    return ResolvedParallelStream;
}();

/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScheduledParallelStream; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__parallel_stream_impl__ = __webpack_require__(49);




/**
 * Stream that has been scheduled on the thread pool and waits for completion of its tasks.
 * @param TSubResult type of the sub results
 * @param TEndResult type of the end result
 */
var ScheduledParallelStream = function () {
    function ScheduledParallelStream(tasks, endResultDefault, join) {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScheduledParallelStream);

        /**
         * Indicator if any task has failed. If this is the case, then registered next handlers are no longer called
         * for outstanding results.
         * @type {boolean}
         * @private
         */
        this.failed = false;
        /**
         * The index of the next expected sub result that should be joined with the end result
         */
        this.nextSubResultIndex = 0;
        this.tasks = tasks;
        this.joiner = join;
        this.endResult = endResultDefault;
        this.pending = tasks.length;
        this.subResults = new Array(this.tasks.length);
        this.innerStream = new __WEBPACK_IMPORTED_MODULE_3__parallel_stream_impl__["a" /* ParallelStream */](function (next, resolve, reject) {
            _this.next = next;
            _this.resolve = resolve;
            _this.reject = reject;
        });
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
            for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(tasks), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var task = _step.value;

                this.registerTaskHandler(task);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally {
            try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                }
            } finally {
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScheduledParallelStream, [{
        key: "subscribe",
        value: function subscribe(onNext, onError, onComplete) {
            this.innerStream.subscribe(onNext, onError, onComplete);
            return this;
        }
    }, {
        key: "then",
        value: function then(onfulfilled, onrejected) {
            return this.innerStream.then(onfulfilled, onrejected);
        }
    }, {
        key: "catch",
        value: function _catch(onrejected) {
            return this.innerStream.catch(onrejected);
        }
    }, {
        key: "registerTaskHandler",
        value: function registerTaskHandler(task) {
            var _this2 = this;

            task.then(function (subResult) {
                return _this2._taskCompleted(subResult, task.definition);
            }, function (reason) {
                return _this2._taskFailed(reason);
            });
        }
    }, {
        key: "_taskCompleted",
        value: function _taskCompleted(subResult, taskDefinition) {
            if (this.pending === 0) {
                throw new Error("Stream already resolved but taskCompleted called one more time");
            }
            --this.pending;
            this.tasks[taskDefinition.taskIndex] = undefined;
            this.subResults[taskDefinition.taskIndex] = subResult;
            if (this.failed) {
                return;
            }
            this.next(subResult, taskDefinition.taskIndex, taskDefinition.valuesPerTask);
            if (this.nextSubResultIndex === taskDefinition.taskIndex) {
                this.joinSubResults();
            }
            if (this.pending === 0) {
                this.resolve(this.endResult);
                this.endResult = undefined;
            }
        }
        /**
         * Joins the currently outstanding sub results. The sub results is needed to ensure that the results are joined in
         * task order. This method iterates until it either reaches the end of the sub results or a sub result for a task is
         * missing (undefined, not yet computed).
         * Has a better memory footprint compared to if all subresults are kept.
         */

    }, {
        key: "joinSubResults",
        value: function joinSubResults() {
            while (this.nextSubResultIndex < this.subResults.length && typeof this.subResults[this.nextSubResultIndex] !== "undefined") {
                var subResult = this.subResults[this.nextSubResultIndex];
                this.subResults[this.nextSubResultIndex] = undefined;
                this.endResult = this.joiner.apply(undefined, [this.endResult, subResult]);
                ++this.nextSubResultIndex;
            }
        }
    }, {
        key: "_taskFailed",
        value: function _taskFailed(reason) {
            if (this.failed === true) {
                return;
            }
            this.failed = true;
            // Cancel all not yet completed tasks
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(this.tasks), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var task = _step2.value;

                    if (typeof task !== "undefined") {
                        task.cancel();
                    }
                }
            } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                        _iterator2.return();
                    }
                } finally {
                    if (_didIteratorError2) {
                        throw _iteratorError2;
                    }
                }
            }

            this.reject(reason);
        }
    }]);

    return ScheduledParallelStream;
}();

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WorkerTask; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);



/**
 * Default implementation of a task. Keeps the state of a state and allows to register handlers that are invoked
 * in case of task completion or error.
 */
var WorkerTask = function () {
    /**
     * Creates a new worker task that executes the operation defined by the given definition
     * @param definition the definition of the operation to execute
     */
    function WorkerTask(definition) {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WorkerTask);

        this.definition = definition;
        this.isCancellationRequested = false;
        this.isCanceled = false;
        this.promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolvePromise, rejectPromise) {
            _this.resolvePromise = resolvePromise;
            _this.rejectPromise = rejectPromise;
        });
    }
    /**
     * Marks the task as complete where the given value is the task result. Triggers all registered `then` handlers of the promise.
     * However, if the task has been cancelled in the mean time, then the `catch` handlers are triggered instead
     * @param result the result of the task execution
     */


    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WorkerTask, [{
        key: "resolve",
        value: function resolve(result) {
            if (this.isCancellationRequested) {
                this.resolveCancelled();
            } else {
                this.resolvePromise(result);
            }
        }
        /**
         * Resolves a task that has been cancelled before start.
         * Triggers all the `catch` handlers.
         */

    }, {
        key: "resolveCancelled",
        value: function resolveCancelled() {
            this.isCanceled = true;
            this.reject("Task has been canceled");
        }
        /**
         * Marks the task as failed
         * @param error the error that occurred while processing the task
         */

    }, {
        key: "reject",
        value: function reject(error) {
            this.rejectPromise(error);
        }
    }, {
        key: "then",
        value: function then(onfulfilled, onrejected) {
            if (onrejected) {
                return this.promise.then(onfulfilled, onrejected);
            }
            return this.promise.then(onfulfilled);
        }
    }, {
        key: "catch",
        value: function _catch(onrejected) {
            return this.promise.catch(onrejected);
        }
    }, {
        key: "cancel",
        value: function cancel() {
            this.isCancellationRequested = true;
        }
    }]);

    return WorkerTask;
}();

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getFunctionName;
/**
 * Returns the name of a function.
 * Function.name contains the name of the function. However, Internet Explorer does not implement this property.
 * Therefore, uses Function.name if defined and otherwise extract the name from source
 * @param func the function for which the name is desired
 * @returns the name of the function or an empty string for an anonymous function
 */
/**
 * Returns the name of a function.
 * Function.name contains the name of the function. However, Internet Explorer does not implement this property.
 * Therefore, uses Function.name if defined and otherwise extract the name from source
 * @param func the function for which the name is desired
 * @returns the name of the function or an empty string for an anonymous function
 */function getFunctionName(func) {
    if (func.hasOwnProperty("name")) {
        return func.name;
    }
    var source = func.toString();
    var functionKeywordStart = source.indexOf("function");
    // Arrow Function Expressions
    if (functionKeywordStart === -1) {
        return "";
    }
    return source.substring(functionKeywordStart + 8, source.indexOf("(")).trim();
}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DefaultWorkerThread; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__worker_messages__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__worker_thread_state__ = __webpack_require__(144);




var workerThreadId = 0;
/**
 * Worker Thread Endpoint in the UI-Thread.
 * Implements the communication with the {@link IWorkerSlave} in the worker thread.
 */
var DefaultWorkerThread = function () {
    /**
     * Creates a new instance that communicates with the given worker
     * @param communicationChannel the {@link IWorkerThreadSlaveCommunicationChannel} to the slave
     * @param functionLookupTable
     */
    function DefaultWorkerThread(functionLookupTable, communicationChannel) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DefaultWorkerThread);

        this.functionLookupTable = functionLookupTable;
        this.communicationChannel = communicationChannel;
        /**
         * Unique id of this worker thread
         */
        this.id = ++workerThreadId;
        /**
         * The current state of the worker thread
         */
        this.state = new __WEBPACK_IMPORTED_MODULE_3__worker_thread_state__["a" /* WorkerThreadState */]("default");
        this.stopped = false;
        var that = this;
        this.communicationChannel.addEventListener("message", function () {
            that.onWorkerMessage.apply(that, arguments);
        });
        this.communicationChannel.addEventListener("error", function () {
            that.onError.apply(that, arguments);
        });
    }
    /**
     * Assigns a unique id to the worker
     * Can only be invoked once. Must be invoked before any task is scheduled.
     */


    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DefaultWorkerThread, [{
        key: "initialize",
        value: function initialize() {
            if (this.state.name !== "default") {
                throw new Error("The worker thread can only be initialized if in state default but actual state is '" + this.state.name + "'.");
            }
            this.communicationChannel.sendMessage(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__worker_messages__["h" /* initializeWorkerMessage */])(this.id));
            this.state = new __WEBPACK_IMPORTED_MODULE_3__worker_thread_state__["a" /* WorkerThreadState */]("idle");
        }
        /**
         * Executes the given task on the worker.
         * Requires that the worker thread has been initialized
         * @param task the task to execute
         * @param callback the callback to invoke when the task has completed (successful or not)
         */

    }, {
        key: "run",
        value: function run(task, callback) {
            var _this = this;

            if (this.state.name !== "idle") {
                throw new Error("The worker thread can only execute a new task if in state idle but actual state is '" + this.state.name + "'.");
            }
            this.communicationChannel.sendMessage(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__worker_messages__["i" /* scheduleTaskMessage */])(task));
            var onComplete = function onComplete(error, result) {
                if (!_this.stopped) {
                    _this.state = new __WEBPACK_IMPORTED_MODULE_3__worker_thread_state__["a" /* WorkerThreadState */]("idle");
                } else {
                    _this.state = new __WEBPACK_IMPORTED_MODULE_3__worker_thread_state__["a" /* WorkerThreadState */]("stopped");
                }
                callback(error, result);
            };
            this.state = new __WEBPACK_IMPORTED_MODULE_3__worker_thread_state__["b" /* WorkerThreadExecutingState */](onComplete, this.functionLookupTable, this.communicationChannel);
        }
        /**
         * Stops the worker as soon as it receives the message. Does not wait to complete the task.
         */

    }, {
        key: "stop",
        value: function stop() {
            if (this.stopped) {
                return;
            }
            this.communicationChannel.sendMessage(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__worker_messages__["j" /* stopMessage */])());
            this.stopped = true;
            if (this.state.name !== "executing") {
                this.state = new __WEBPACK_IMPORTED_MODULE_3__worker_thread_state__["a" /* WorkerThreadState */]("stopped");
            }
        }
    }, {
        key: "toString",
        value: function toString() {
            return "WorkerThread { id: " + this.id + ", state: " + this.state.name;
        }
    }, {
        key: "onWorkerMessage",
        value: function onWorkerMessage(message) {
            this.state.onMessage(message);
        }
    }, {
        key: "onError",
        value: function onError(event) {
            this.state.onError(event);
            this.state = new __WEBPACK_IMPORTED_MODULE_3__worker_thread_state__["a" /* WorkerThreadState */]("errored");
        }
    }]);

    return DefaultWorkerThread;
}();

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return WorkerThreadState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return WorkerThreadExecutingState; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_get__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__worker_messages__ = __webpack_require__(41);








/**
 * State of the worker thread
 */
var WorkerThreadState = function () {
    function WorkerThreadState(name) {
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, WorkerThreadState);

        this.name = name;
    }
    /**
     * Called if the worker thread has received a message from a slave
     * @param event the received message
     */


    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(WorkerThreadState, [{
        key: "onMessage",
        value: function onMessage(message) {
            throw new Error("Worker thread in state '" + this.name + "' cannot handle the received message (" + message.type + ").");
        }
        /**
         * Called if a fatal error on the Slave. Errors occurring during task execution are specially handled
         * and passed to {@link WorkerThreadState.onMessage}
         * @param error
         */

    }, {
        key: "onError",
        value: function onError(error) {
            console.error("Processing error on worker slave", error);
        }
    }]);

    return WorkerThreadState;
}();
/**
 * Worker thread is executing a function on the {@link IWorkerSlave}
 */
var WorkerThreadExecutingState = function (_WorkerThreadState) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WorkerThreadExecutingState, _WorkerThreadState);

    function WorkerThreadExecutingState(callback, functionRegistry, communicationChannel) {
        __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, WorkerThreadExecutingState);

        var _this = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WorkerThreadExecutingState.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WorkerThreadExecutingState)).call(this, "executing"));

        _this.callback = callback;
        _this.functionRegistry = functionRegistry;
        _this.communicationChannel = communicationChannel;
        return _this;
    }

    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(WorkerThreadExecutingState, [{
        key: "onMessage",
        value: function onMessage(message) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__worker_messages__["k" /* isFunctionRequest */])(message)) {
                this.handleFunctionRequest(message);
            } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__worker_messages__["l" /* isWorkerResult */])(message)) {
                this.callback(undefined, message.result);
            } else if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__worker_messages__["m" /* isFunctionExecutionError */])(message)) {
                this.callback(message.error, undefined);
            } else {
                __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_get___default()(WorkerThreadExecutingState.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(WorkerThreadExecutingState.prototype), "onMessage", this).call(this, message);
            }
        }
    }, {
        key: "onError",
        value: function onError(error) {
            this.callback(error, undefined);
        }
    }, {
        key: "handleFunctionRequest",
        value: function handleFunctionRequest(message) {
            var missingIds = [];
            var definitions = [];
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(message.functionIds), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var functionId = _step.value;

                    var definition = this.functionRegistry.getDefinition(functionId);
                    if (definition) {
                        definitions.push(definition);
                    } else {
                        missingIds.push(functionId);
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            this.communicationChannel.sendMessage(__WEBPACK_IMPORTED_MODULE_7__worker_messages__["n" /* functionResponseMessage */].apply(undefined, [definitions].concat(missingIds)));
        }
    }]);

    return WorkerThreadExecutingState;
}(WorkerThreadState);

/***/ }),
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ChildProcessWorkerThreadSlaveCommunicationChannel; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_worker_worker_messages__ = __webpack_require__(41);



var ChildProcessWorkerThreadSlaveCommunicationChannel = function () {
    function ChildProcessWorkerThreadSlaveCommunicationChannel(child) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ChildProcessWorkerThreadSlaveCommunicationChannel);

        this.child = child;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ChildProcessWorkerThreadSlaveCommunicationChannel, [{
        key: "sendMessage",
        value: function sendMessage(message) {
            if (__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__common_worker_worker_messages__["a" /* isStopMesssage */])(message)) {
                this.child.kill();
            } else {
                this.child.send(message);
            }
        }
    }, {
        key: "addEventListener",
        value: function addEventListener(type, listener) {
            this.child.addListener(type, listener);
        }
    }]);

    return ChildProcessWorkerThreadSlaveCommunicationChannel;
}();

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(148), __esModule: true };

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _getPrototypeOf = __webpack_require__(42);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _getOwnPropertyDescriptor = __webpack_require__(146);

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = (0, _getOwnPropertyDescriptor2.default)(object, property);

  if (desc === undefined) {
    var parent = (0, _getPrototypeOf2.default)(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(157);
var $Object = __webpack_require__(2).Object;
module.exports = function getOwnPropertyDescriptor(it, key){
  return $Object.getOwnPropertyDescriptor(it, key);
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(72);
__webpack_require__(28);
__webpack_require__(48);
__webpack_require__(158);
module.exports = __webpack_require__(2).Promise;

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports = function(it, Constructor, name, forbiddenField){
  if(!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)){
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var ctx         = __webpack_require__(16)
  , call        = __webpack_require__(70)
  , isArrayIter = __webpack_require__(69)
  , anObject    = __webpack_require__(7)
  , toLength    = __webpack_require__(46)
  , getIterFn   = __webpack_require__(47)
  , BREAK       = {}
  , RETURN      = {};
var exports = module.exports = function(iterable, entries, fn, that, ITERATOR){
  var iterFn = ITERATOR ? function(){ return iterable; } : getIterFn(iterable)
    , f      = ctx(fn, that, entries ? 2 : 1)
    , index  = 0
    , length, step, iterator, result;
  if(typeof iterFn != 'function')throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if(isArrayIter(iterFn))for(length = toLength(iterable.length); length > index; index++){
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if(result === BREAK || result === RETURN)return result;
  } else for(iterator = iterFn.call(iterable); !(step = iterator.next()).done; ){
    result = call(iterator, f, step.value, entries);
    if(result === BREAK || result === RETURN)return result;
  }
};
exports.BREAK  = BREAK;
exports.RETURN = RETURN;

/***/ }),
/* 152 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function(fn, args, that){
  var un = that === undefined;
  switch(args.length){
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return              fn.apply(that, args);
};

/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var global    = __webpack_require__(4)
  , macrotask = __webpack_require__(108).set
  , Observer  = global.MutationObserver || global.WebKitMutationObserver
  , process   = global.process
  , Promise   = global.Promise
  , isNode    = __webpack_require__(21)(process) == 'process';

module.exports = function(){
  var head, last, notify;

  var flush = function(){
    var parent, fn;
    if(isNode && (parent = process.domain))parent.exit();
    while(head){
      fn   = head.fn;
      head = head.next;
      try {
        fn();
      } catch(e){
        if(head)notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if(parent)parent.enter();
  };

  // Node.js
  if(isNode){
    notify = function(){
      process.nextTick(flush);
    };
  // browsers with MutationObserver
  } else if(Observer){
    var toggle = true
      , node   = document.createTextNode('');
    new Observer(flush).observe(node, {characterData: true}); // eslint-disable-line no-new
    notify = function(){
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if(Promise && Promise.resolve){
    var promise = Promise.resolve();
    notify = function(){
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function(){
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function(fn){
    var task = {fn: fn, next: undefined};
    if(last)last.next = task;
    if(!head){
      head = task;
      notify();
    } last = task;
  };
};

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(11);
module.exports = function(target, src, safe){
  for(var key in src){
    if(safe && target[key])target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};

/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global      = __webpack_require__(4)
  , core        = __webpack_require__(2)
  , dP          = __webpack_require__(6)
  , DESCRIPTORS = __webpack_require__(8)
  , SPECIES     = __webpack_require__(3)('species');

module.exports = function(KEY){
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if(DESCRIPTORS && C && !C[SPECIES])dP.f(C, SPECIES, {
    configurable: true,
    get: function(){ return this; }
  });
};

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject  = __webpack_require__(7)
  , aFunction = __webpack_require__(51)
  , SPECIES   = __webpack_require__(3)('species');
module.exports = function(O, D){
  var C = anObject(O).constructor, S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject                 = __webpack_require__(9)
  , $getOwnPropertyDescriptor = __webpack_require__(44).f;

__webpack_require__(45)('getOwnPropertyDescriptor', function(){
  return function getOwnPropertyDescriptor(it, key){
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});

/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY            = __webpack_require__(26)
  , global             = __webpack_require__(4)
  , ctx                = __webpack_require__(16)
  , classof            = __webpack_require__(67)
  , $export            = __webpack_require__(5)
  , isObject           = __webpack_require__(14)
  , aFunction          = __webpack_require__(51)
  , anInstance         = __webpack_require__(150)
  , forOf              = __webpack_require__(151)
  , speciesConstructor = __webpack_require__(156)
  , task               = __webpack_require__(108).set
  , microtask          = __webpack_require__(153)()
  , PROMISE            = 'Promise'
  , TypeError          = global.TypeError
  , process            = global.process
  , $Promise           = global[PROMISE]
  , process            = global.process
  , isNode             = classof(process) == 'process'
  , empty              = function(){ /* empty */ }
  , Internal, GenericPromiseCapability, Wrapper;

var USE_NATIVE = !!function(){
  try {
    // correct subclassing with @@species support
    var promise     = $Promise.resolve(1)
      , FakePromise = (promise.constructor = {})[__webpack_require__(3)('species')] = function(exec){ exec(empty, empty); };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
  } catch(e){ /* empty */ }
}();

// helpers
var sameConstructor = function(a, b){
  // with library wrapper special case
  return a === b || a === $Promise && b === Wrapper;
};
var isThenable = function(it){
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var newPromiseCapability = function(C){
  return sameConstructor($Promise, C)
    ? new PromiseCapability(C)
    : new GenericPromiseCapability(C);
};
var PromiseCapability = GenericPromiseCapability = function(C){
  var resolve, reject;
  this.promise = new C(function($$resolve, $$reject){
    if(resolve !== undefined || reject !== undefined)throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject  = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject  = aFunction(reject);
};
var perform = function(exec){
  try {
    exec();
  } catch(e){
    return {error: e};
  }
};
var notify = function(promise, isReject){
  if(promise._n)return;
  promise._n = true;
  var chain = promise._c;
  microtask(function(){
    var value = promise._v
      , ok    = promise._s == 1
      , i     = 0;
    var run = function(reaction){
      var handler = ok ? reaction.ok : reaction.fail
        , resolve = reaction.resolve
        , reject  = reaction.reject
        , domain  = reaction.domain
        , result, then;
      try {
        if(handler){
          if(!ok){
            if(promise._h == 2)onHandleUnhandled(promise);
            promise._h = 1;
          }
          if(handler === true)result = value;
          else {
            if(domain)domain.enter();
            result = handler(value);
            if(domain)domain.exit();
          }
          if(result === reaction.promise){
            reject(TypeError('Promise-chain cycle'));
          } else if(then = isThenable(result)){
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch(e){
        reject(e);
      }
    };
    while(chain.length > i)run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if(isReject && !promise._h)onUnhandled(promise);
  });
};
var onUnhandled = function(promise){
  task.call(global, function(){
    var value = promise._v
      , abrupt, handler, console;
    if(isUnhandled(promise)){
      abrupt = perform(function(){
        if(isNode){
          process.emit('unhandledRejection', value, promise);
        } else if(handler = global.onunhandledrejection){
          handler({promise: promise, reason: value});
        } else if((console = global.console) && console.error){
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if(abrupt)throw abrupt.error;
  });
};
var isUnhandled = function(promise){
  if(promise._h == 1)return false;
  var chain = promise._a || promise._c
    , i     = 0
    , reaction;
  while(chain.length > i){
    reaction = chain[i++];
    if(reaction.fail || !isUnhandled(reaction.promise))return false;
  } return true;
};
var onHandleUnhandled = function(promise){
  task.call(global, function(){
    var handler;
    if(isNode){
      process.emit('rejectionHandled', promise);
    } else if(handler = global.onrejectionhandled){
      handler({promise: promise, reason: promise._v});
    }
  });
};
var $reject = function(value){
  var promise = this;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if(!promise._a)promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function(value){
  var promise = this
    , then;
  if(promise._d)return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if(promise === value)throw TypeError("Promise can't be resolved itself");
    if(then = isThenable(value)){
      microtask(function(){
        var wrapper = {_w: promise, _d: false}; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch(e){
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch(e){
    $reject.call({_w: promise, _d: false}, e); // wrap
  }
};

// constructor polyfill
if(!USE_NATIVE){
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor){
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch(err){
      $reject.call(this, err);
    }
  };
  Internal = function Promise(executor){
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(154)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected){
      var reaction    = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok     = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail   = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if(this._a)this._a.push(reaction);
      if(this._s)notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function(onRejected){
      return this.then(undefined, onRejected);
    }
  });
  PromiseCapability = function(){
    var promise  = new Internal;
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject  = ctx($reject, promise, 1);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, {Promise: $Promise});
__webpack_require__(27)($Promise, PROMISE);
__webpack_require__(155)(PROMISE);
Wrapper = __webpack_require__(2)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r){
    var capability = newPromiseCapability(this)
      , $$reject   = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x){
    // instanceof instead of internal slot check because we should fix it without replacement native Promise core
    if(x instanceof $Promise && sameConstructor(x.constructor, this))return x;
    var capability = newPromiseCapability(this)
      , $$resolve  = capability.resolve;
    $$resolve(x);
    return capability.promise;
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(71)(function(iter){
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , resolve    = capability.resolve
      , reject     = capability.reject;
    var abrupt = perform(function(){
      var values    = []
        , index     = 0
        , remaining = 1;
      forOf(iterable, false, function(promise){
        var $index        = index++
          , alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function(value){
          if(alreadyCalled)return;
          alreadyCalled  = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable){
    var C          = this
      , capability = newPromiseCapability(C)
      , reject     = capability.reject;
    var abrupt = perform(function(){
      forOf(iterable, false, function(promise){
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if(abrupt)reject(abrupt.error);
    return capability.promise;
  }
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports = require("child_process");

/***/ }),
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var parallel = __webpack_require__(122).default;
module.exports = parallel;


/***/ })
/******/ ]);
});


// WEBPACK FOOTER //
// node-commonjs.parallel.js